import React, { useRef, useState, useEffect } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { motion } from "framer-motion";
import { useDispatch } from "react-redux";
import { increment, decrement } from "../../../Redux/Action/Action";
import Slider from "react-slick";
import ContactModal from "../../model/ContactModal";
import { useLocation, useNavigate } from "react-router-dom";
import { useUserAuth } from "../../../context/AppContext";
import { Link } from "react-router-dom";

import CloudComputingBanImg from "../../../assets/images/cloud-computing-ban.jpg";
import { Helmet } from "react-helmet";
// import { MetaTags } from "react-meta-tags";
function CloudComputing() {
  const { subActive, setSubActive } = useUserAuth();
  const [commonModal, setCommonModal] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const routePath = useLocation();
  const location = useLocation();
  const path = location.pathname;
  const scrollToRef = useRef();
  const accuratePath = routePath.pathname;

  useEffect(() => {
    if (accuratePath === "/cloud-computing") {
      window.scroll({
        top: 0,
        behavior: "instant",
      });
    }

    if (
      accuratePath === "/cloud-computing" ||
      accuratePath === "/cloud-computing/cloud-infrastructure" ||
      accuratePath === "/cloud-computing/server-management" ||
      accuratePath === "/server-management" ||
      accuratePath === "/cloud-computing/server-management-kindlebit" ||
      accuratePath === "/cloud-computing/database-management" ||
      accuratePath === "/backup-management" ||
      accuratePath === "/cloud-computing/iaas" ||
      accuratePath === "/cloud-computing/paas" ||
      accuratePath === "/cloud-computing/saas"
    ) {
      setSubActive(0);
    }
    // eslint-disable-next-line
  }, [accuratePath]);

  useEffect(() => {
    var count = 0;
    var path = routePath.pathname;
    for (var i = 0; i < path.length; i++) {
      if (path[i] === "/") {
        count++;
      }
    }
    if (count > 1) {
      scrollToRef.current.scrollIntoView();
    }
  }, [routePath, subActive]);

  const settings = {
    prevArrow: (
      <button
        type="button"
        className="slick-prev"
        onMouseOver={() => dispatch(increment())}
        onMouseLeave={() => dispatch(decrement())}
      >
        Previous
      </button>
    ),
    nextArrow: (
      <button
        type="button"
        className="slick-next"
        onMouseOver={() => dispatch(increment())}
        onMouseLeave={() => dispatch(decrement())}
      >
        Next
      </button>
    ),
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 499,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      {/* <MetaTags>
        <meta
          id="meta-description"
          name="description"
          content="Learn about SaaS, IaaS, PaaS, and server management, among other complete cloud services. Increase efficiency and resource optimization with us!"
        />
      </MetaTags> */}
      <Helmet>
        <title>Discover the Reliable Cloud Service Provider for SaaS Solutions</title>
        <meta
          name="keyword"
          content="cloud service provider, saas and cloud computing"
        />
        <meta
          name="description"
          content="Power your business with top-tier cloud service providers. Experience seamless SaaS and cloud computing for smarter, faster operations."
        />
      </Helmet>

      <main className="inner-page" id="services-cloud-computing">
        <section className="banner dark">
          <img className="banner-img" src={CloudComputingBanImg} alt="..." />
          <div className="banner-inner container">
            <div className="banner-heading">
              <div className="sap-lg-heading">Cloud Computing</div>
              <div className="text-para">
                Cloud computing is the on-demand delivery of IT resources over
                the Internet with pay-as-you-go pricing. Store, manage & process
                data in a centralized way on the network of remote servers
                hosted on the internet. Kindlebit takes pride in providing
                security from the ground up, backed by a team of experts, and
                proactive compliance trusted by organizations, governments and
                startups.
              </div>
            </div>
          </div>
        </section>
        <section className="sap-card">
          <div
            className="back-blue-art"
            data-aos="fade-right"
            data-aos-duration="800"
            data-aos-delay="300"
            data-aos-offset="0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="194.877"
              height="397.823"
              viewBox="0 0 194.877 397.823"
            >
              <g
                id="Group_67"
                data-name="Group 67"
                transform="translate(-2996.562 -104.677)"
              >
                <rect
                  id="Rectangle_90"
                  data-name="Rectangle 90"
                  width="194.877"
                  height="397.823"
                  rx="97.439"
                  transform="translate(2996.562 104.677)"
                  fill="#00224b"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_93"
                  data-name="Rectangle 93"
                  width="117.351"
                  height="318"
                  rx="58.675"
                  transform="translate(3035.325 144.589)"
                  fill="#00224b"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_94"
                  data-name="Rectangle 94"
                  width="55.803"
                  height="237"
                  rx="27.901"
                  transform="translate(3066.099 185.088)"
                  fill="#00224b"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_95"
                  data-name="Rectangle 95"
                  width="16.199"
                  height="175.098"
                  rx="8.099"
                  transform="translate(3085.901 216.039)"
                  fill="#00224b"
                  opacity="0.05"
                />
              </g>
            </svg>
          </div>

          <div
            className="back-orange-art"
            data-aos="fade-left"
            data-aos-duration="800"
            data-aos-delay="300"
            data-aos-offset="0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="252.883"
              height="123.877"
              viewBox="0 0 252.883 123.877"
            >
              <g
                id="Group_68"
                data-name="Group 68"
                transform="translate(-4187.117 -707.061)"
              >
                <rect
                  id="Rectangle_99"
                  data-name="Rectangle 99"
                  width="123.877"
                  height="252.883"
                  rx="61.939"
                  transform="translate(4440 707.061) rotate(90)"
                  fill="#f38020"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_100"
                  data-name="Rectangle 100"
                  width="74.596"
                  height="202.142"
                  rx="37.298"
                  transform="translate(4414.629 731.702) rotate(90)"
                  fill="#f38020"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_101"
                  data-name="Rectangle 101"
                  width="35.472"
                  height="150.653"
                  rx="17.736"
                  transform="translate(4388.885 751.264) rotate(90)"
                  fill="#f38020"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_102"
                  data-name="Rectangle 102"
                  width="10.297"
                  height="111.304"
                  rx="5.148"
                  transform="translate(4369.21 763.851) rotate(90)"
                  fill="#f38020"
                  opacity="0.05"
                />
              </g>
            </svg>
          </div>

          <div className="sap-card-inner container">
            <div className="sec-heading">
              <div className="sap-caption-head">
                <div className="sap-caption">what our services say</div>
              </div>
              <div ref={scrollToRef} className="sap-lg-heading">
                Our services
                <br />
                that we provide
              </div>
            </div>
            <Slider
              {...settings}
              className="services-slider owl-carousel owl-theme"
            >
              <Link to="/cloud-computing/cloud-infrastructure">
                <div
                  className={
                    accuratePath === "/cloud-computing" ||
                      accuratePath === "/cloud-computing/cloud-infrastructure"
                      ? "item we-deals-list-inner active"
                      : "item we-deals-list-inner"
                  }
                  id="8"
                  onClick={() => setSubActive(0)}
                >
                  <div className="wdi-icon">
                    <svg data-name="Layer 1" viewBox="0 0 260.67 290">
                      <path
                        fill="#9cb5d4"
                        d="M130.37 290c-1.64 0-3.31-.51-5.09-1.55-8.14-4.76-17.02-9.84-27.16-15.53-3.51-1.97-5.05-4.59-5.02-8.51.1-10.37.1-21.18 0-33.05-.03-3.83 1.47-6.39 4.87-8.3 4.28-2.41 8.55-4.85 12.81-7.29 4.37-2.5 8.89-5.09 13.36-7.59 2.31-1.29 3.32-3.01 3.26-5.56-.09-4.29-.08-8.55-.06-13.06 0-1.76.01-3.55.01-5.37v-1.96H48.89c-6.28 0-8.74 2.49-8.76 8.86 0 1.31 0 2.61.01 3.92.01 2.56.03 5.21-.05 7.8-.07 2.36.85 3.94 2.99 5.14 3.52 1.97 7.02 3.98 10.52 5.99 4.96 2.85 10.08 5.79 15.19 8.58 4.09 2.24 5.8 5.19 5.71 9.85-.22 11.12-.13 22.31-.03 31.93.04 3.97-1.48 6.62-4.95 8.58-8.09 4.58-17.64 10-27.15 15.55-1.78 1.04-3.45 1.54-5.11 1.54s-3.45-.54-5.32-1.64c-7.68-4.53-15.98-9.28-26.92-15.4-3.5-1.96-5.05-4.59-5.02-8.52.08-10.51.08-21.32 0-33.04-.03-3.84 1.48-6.41 4.87-8.31 4.27-2.4 8.53-4.83 12.78-7.27 4.38-2.51 8.92-5.1 13.39-7.61 2.33-1.31 3.33-3.03 3.24-5.59-.14-3.74-.09-7.57-.05-11.28v-1.25c.11-8.43 5.38-13.68 13.78-13.69 10.86-.01 21.72-.02 32.58-.02h46.72v-1.95c0-1.26 0-2.51.01-3.75.02-3.97.03-7.72-.11-11.55-.06-1.67-1.69-2.83-3.11-3.64-1.67-.96-3.33-1.93-5-2.9-6.1-3.54-12.4-7.21-18.74-10.6-5.05-2.7-8.01-5.52-7.15-11.2l.32-2.14-2.16-.11c-.42-.02-.82-.04-1.19-.07-.81-.05-1.53-.09-2.25-.09H71.77c-3.22 0-6.45 0-9.67-.04-21.54-.21-38.45-14.63-42.06-35.89-1.8-10.56.97-21.84 7.6-30.96 6.57-9.04 16.35-15.11 26.83-16.65 4.02-.59 6.05-2.28 7.5-6.23 8-21.76 23.78-34.6 46.94-38.13.55-.08 1.02-.25 1.44-.39l.18-.06h10.37c1.41.34 2.83.64 4.25.95 3.16.69 6.43 1.4 9.49 2.42 9.2 3.06 17.33 8.63 24.16 16.55.34.4.7.79 1.08 1.21l1.49 1.64 1.29-.56c4.09-1.79 7.94-2.66 11.75-2.66 2.02 0 4.05.26 6.03.76 10.65 2.72 17.53 9.42 20.45 19.91.57 2.05 1.56 4.01 4.87 4.53 21.6 3.35 36.38 22.26 35.16 44.96-1.1 20.45-18.93 37.72-39.75 38.5-3.49.13-7.33.19-12.07.19-2.46 0-4.93-.02-7.39-.03-2.47-.02-4.94-.03-7.41-.03h-6.42l-.15 1.79c-.03.34-.06.63-.09.9-.06.58-.12 1.08-.11 1.62.06 3.46-1.44 5.94-4.73 7.8-3.62 2.05-7.23 4.12-10.83 6.18-5.1 2.92-10.37 5.93-15.57 8.86-1.51.85-3.24 2.23-3.15 5.34.09 3.07.07 6.15.05 9.41 0 1.35-.01 2.74-.01 4.16v1.96h78.38c9.63 0 14.73 5.09 14.75 14.72 0 1.07.02 2.14.03 3.21.04 2.59.07 5.27-.09 7.86-.22 3.58 1.73 5.17 3.68 6.25 4.24 2.36 8.52 4.81 12.66 7.19 4.17 2.39 8.49 4.87 12.77 7.25 3.65 2.03 5.25 4.8 5.2 8.99-.13 10.78-.13 21.61 0 32.2.05 4.2-1.55 6.97-5.19 9.01-8.57 4.79-17.38 9.82-26.92 15.39-1.8 1.05-3.48 1.56-5.13 1.56s-3.29-.5-5.05-1.53c-9.88-5.79-19.71-11.34-27.17-15.53-3.51-1.97-5.06-4.6-5.02-8.52.09-10.05.1-20.86 0-33.05-.03-3.82 1.48-6.38 4.89-8.3 4.11-2.31 8.19-4.65 12.28-6.99 4.54-2.61 9.24-5.3 13.89-7.89 2.39-1.33 3.41-3.14 3.32-5.84-.08-2.22-.06-4.51-.05-6.72.01-1.93.02-3.92-.02-5.89-.11-4.74-2.84-7.46-7.48-7.47-11.41-.02-22.81-.02-34.22-.02-10.6 0-21.21 0-31.82.01h-10.05c-.49 0-.91.09-1.35.18-.18.04-.38.08-.62.12l-1.64.27v6.16c-.01 5.03-.02 10.24.1 15.35.03 1.32 1.05 2.57 3.03 3.71l2.14 1.24c7.69 4.44 15.64 9.03 23.55 13.4 3.89 2.15 5.51 4.97 5.44 9.43-.19 11.53-.12 22.75-.02 32.21.04 3.98-1.48 6.62-4.94 8.57-8.47 4.78-17.43 9.91-27.39 15.68-1.68.97-3.26 1.44-4.85 1.44zm28.13-55.46c-2 1.14-3.96 2.29-5.91 3.42-4.6 2.69-8.95 5.23-13.49 7.5-4.39 2.19-6.16 5.25-5.92 10.25.25 5.35.2 10.69.15 16.35-.02 2.41-.05 4.87-.05 7.38v3.37s7.09-4.05 9.11-5.2c5.54-3.17 10.77-6.16 16.06-9.09 2.31-1.28 3.28-2.93 3.24-5.53-.08-5.52-.07-11.14-.06-16.57v-7.49c0-.62-.06-1.21-.12-1.84-.03-.3-.06-.63-.09-.99l-.24-3.08-2.68 1.53zM5.92 242.05c0 7.53 0 14.64.05 21.88 0 1.27.71 3.02 1.99 3.77 6.01 3.5 12.01 6.92 18.36 10.54l7.92 4.51v-9.57c.01-7.59.02-14.75-.09-21.97-.03-2.26-2.66-3.86-2.96-4.03-5.74-3.36-11.62-6.7-17.31-9.92l-2.84-1.61c-.5-.28-1-.5-1.54-.72-.25-.11-.52-.22-.82-.35l-2.76-1.24v8.72zm59.71-7.66c-2.09 1.19-4.13 2.36-6.15 3.52-5.51 3.16-10.71 6.14-16 9.07-2.43 1.34-3.45 3.06-3.4 5.74.09 5.44.07 10.99.06 16.35v7.42c0 .62.06 1.21.12 1.89.03.33.06.69.09 1.09l.24 3.08 7.15-4.07c6.53-3.72 12.71-7.23 18.95-10.84 1.04-.6 1.84-2.02 1.84-3.29.04-7.56.04-15.04.04-22.95v-8.69l-2.93 1.67zm180.11 3.49c-5.61 3.21-10.91 6.25-16.29 9.24-2.15 1.19-3.1 2.84-3.08 5.33.06 5.44.05 10.98.05 16.33v8.01c0 .58.07 1.11.14 1.73.03.29.07.6.11.96l.3 3 7.21-4.11c6.39-3.64 12.43-7.08 18.53-10.62 1.11-.65 1.96-2.16 1.97-3.51.05-7.37.05-14.68.05-22.43v-9.07s-7 4-8.98 5.14zm-53.66 4.14c0 7.54 0 14.66.05 21.92.01 1.24.72 2.97 2.01 3.73 6.04 3.53 12.03 6.95 18.38 10.57l7.32 4.18.42-2.84c.04-.31.09-.55.12-.74.07-.42.13-.74.13-1.14v-5.17c.03-6.77.05-13.77-.08-20.66-.03-1.81-1.52-3.76-2.93-4.6-5.72-3.4-11.6-6.73-17.28-9.96l-3.36-1.91c-.51-.29-1.01-.46-1.5-.62-.2-.07-.41-.14-.63-.22l-2.65-.99v8.44zm-93.08.29c0 7.45-.02 14.48.08 21.58.02 1.7 1.39 3.42 2.67 4.18 6.04 3.56 12.23 7.08 18.22 10.48l2.4 1.37c.52.29 1.03.46 1.57.64.23.08.49.16.78.26l2.63.96v-8.15c0-7.73 0-15.03-.05-22.46-.01-1.45-1.08-2.86-2.08-3.44-6.01-3.5-11.99-6.92-18.32-10.54l-7.89-4.51v9.63zm124.39-30.07c-.59 0-1.47.09-2.25.52-5.94 3.29-11.77 6.62-17.94 10.15l-8.2 4.68 7.92 4.51c6.43 3.67 12.5 7.13 18.68 10.56.46.26 1 .39 1.62.39 1.07 0 2.16-.4 2.82-.77 7.01-3.92 14.08-7.98 20.92-11.9.52-.3.92-.66 1.31-1.01.16-.14.32-.29.51-.44l2.19-1.8-7.51-4.3c-6.04-3.46-11.75-6.73-17.61-10-.68-.38-1.55-.58-2.47-.58zm-186.14-.1c-.8 0-1.57.18-2.16.51-6.08 3.4-12.25 6.92-18.21 10.33l-6.78 3.87 1.53 1.8c.08.1.15.18.2.26.21.28.5.67 1 .95l3.56 2.05c6.08 3.5 12.36 7.11 18.61 10.56.55.3 1.21.46 1.97.46 1 0 2.1-.27 2.95-.73 4.12-2.25 8.26-4.62 12.26-6.91l3.23-1.85c1.56-.89 3.12-1.79 4.78-2.75l5.37-3.1-7.75-4.44c-6.36-3.64-12.36-7.08-18.47-10.51-.73-.41-1.54-.49-2.09-.49zm93.2-.05c-.8 0-1.61.2-2.23.55-6.1 3.42-12.09 6.84-18.43 10.45l-7.71 4.39 2.83 1.73 1.05.65c.68.42 1.28.8 1.89 1.14 1.69.96 3.39 1.9 5.1 2.84 3.73 2.05 7.59 4.17 11.15 6.53 2.3 1.53 4.31 2.24 6.35 2.24 2.08 0 4.14-.77 6.31-2.37 2.21-1.62 4.65-2.93 7.22-4.31 1.16-.62 2.33-1.25 3.47-1.9 1.72-.99 8.25-4.74 8.25-4.74l2.96-1.7-7.61-4.36c-6.48-3.72-12.6-7.22-18.83-10.72-.5-.28-1.1-.42-1.78-.42zm23.13-107.07c-3.71 2.1-7.31 4.14-10.89 6.22-.72.42-1.52.8-2.36 1.22-2.44 1.18-4.96 2.41-6.31 4.68-1.31 2.2-1.09 4.94-.88 7.58.08.95.15 1.85.14 2.68-.02 4.5-.02 9-.01 13.71v9.42l8.3-4.73c6.19-3.53 12.04-6.86 17.86-10.3 1.55-.92 2.14-3.18 2.15-4.48.08-7.34.07-14.79.05-22v-2.67c0-.6-.09-1.16-.18-1.75-.04-.26-.08-.54-.12-.86l-.37-2.9-7.37 4.19zm-53.85-1.9c-.08.14-.15.25-.2.33-.18.28-.47.74-.47 1.41l-.02 4.2c-.03 7.45-.06 15.16.03 22.75.02 1.76 1.56 3.32 2.59 3.94 3.47 2.08 7.03 4.11 10.48 6.07l2.69 1.53c2.1 1.19 4.2 2.38 6.36 3.6l5.3 3 .53-2.66c.05-.23.09-.42.13-.58.09-.39.18-.76.18-1.22v-4.85c.03-6.96.05-14.16-.07-21.25-.03-1.74-1.48-3.55-2.83-4.36-3.68-2.22-7.48-4.37-11.15-6.45-1.26-.71-2.52-1.43-3.77-2.14l-8.83-5.03-.96 1.74zM61.72 49.93c-5.1 0-10.21 1.17-15.19 3.48-15.35 7.13-23.68 23.64-20.26 40.15 3.45 16.64 17.75 28.5 34.77 28.84 2.98.06 6.21.09 10.14.09 2.38 0 4.77 0 7.15-.02 2.38 0 4.76-.02 7.14-.02h7.43l.08-1.87c.02-.41.04-.79.06-1.15.04-.76.08-1.41.08-2.07 0-1.65.02-3.3.03-4.95.03-4.22.06-8.59-.06-12.9-.12-4.12 1.48-6.88 5.19-8.95 9.08-5.08 18.14-10.26 26.91-15.39 1.8-1.05 3.48-1.57 5.14-1.57s3.28.5 5.04 1.52c9.29 5.42 17.69 10.3 26.44 15.09 4.19 2.29 5.91 5.22 5.75 9.77-.16 4.69-.13 9.47-.09 14.1.02 2.05.03 4.11.03 6.19v1.71l1.7.23c.28.04.51.07.7.1.4.06.74.12 1.14.12h.26c2.8 0 5.61.01 8.41.03 2.81.01 5.62.03 8.43.03 4.75 0 8.63-.04 12.22-.12 14.32-.33 27.36-9.74 32.46-23.42 5.18-13.9 1.56-29.29-9.22-39.22-6.82-6.28-15.55-9.75-24.58-9.75-7.71 0-15.2 2.47-21.67 7.15-1.27.92-2.42 1.4-3.32 1.4-.49 0-1.22-.12-1.98-1.18-.51-.71-1.71-2.36 1.87-5a41.45 41.45 0 0115.3-7.05c.98-.23 1.96-.44 2.95-.66l3.18-.7-.23-1.78-.05-.42c-.04-.35-.07-.61-.14-.86l-.03-.11c-.12-.47-.25-1-.48-1.53-3.61-8.56-10.2-13.29-19.08-13.66-.37-.02-.74-.02-1.11-.02-8.34 0-14.96 4.12-19.13 11.92-.54 1.02-1.68 2.72-3.15 2.72-.41 0-.86-.13-1.34-.38-.73-.38-1.19-.91-1.39-1.57-.27-.92-.03-2.12.69-3.4 1.01-1.79 2.19-3.51 3.45-5.33.59-.85 1.19-1.73 1.79-2.63l.83-1.25-1-1.13c-10.91-12.36-23.84-18.63-38.44-18.63-3.14 0-6.39.29-9.67.88-19.5 3.46-32.91 15.13-39.86 34.71l-.64 1.8 1.78.68c1.43.55 2.83 1.07 4.23 1.59 3.22 1.2 6.26 2.33 9.24 3.64.96.42 1.61 1.03 1.88 1.75.25.66.18 1.42-.19 2.2-.51 1.08-1.3 1.61-2.42 1.61-.63 0-1.34-.17-2.09-.51-.26-.12-.52-.25-.78-.39-.34-.17-.68-.35-1.03-.51-5.09-2.27-10.24-3.42-15.3-3.42zm68.86 29.92c-1.04 0-2.12.38-2.78.73-2.75 1.48-5.48 3.05-8.13 4.57l-2.37 1.36c-2.93 1.67-5.85 3.34-8.89 5.09l-6.5 3.72 7.69 4.39c3.44 1.96 6.75 3.85 10.07 5.73.86.49 1.74 1.09 2.67 1.74 2.43 1.68 4.94 3.41 7.76 3.41 2.96-.01 5.59-1.76 8.13-3.44.92-.61 1.79-1.18 2.64-1.66 3.4-1.9 6.79-3.83 10.3-5.84 1.51-.87 7.61-4.34 7.61-4.34l-7.82-4.46c-6.44-3.68-12.53-7.16-18.74-10.59-.47-.26-1.02-.39-1.64-.39z"
                      />
                    </svg>
                  </div>
                  <div className="wdi-heading">Cloud Infrastructure</div>
                </div>
              </Link>
              <Link to="/cloud-computing/server-management">
                <div
                  className={
                    accuratePath === "/server-management" ||
                      accuratePath === "/cloud-computing/server-management"
                      ? "item we-deals-list-inner active"
                      : "item we-deals-list-inner"
                  }
                  id="8"
                  onClick={() => setSubActive(0)}
                >
                  <div className="wdi-icon">
                    <svg data-name="Layer 1" viewBox="0 0 320.42 298">
                      <path
                        fill="#9cb5d4"
                        d="M161.86 298c-9.12 0-17.02-6.36-18.79-15.13-1.83-9.08 2.94-18.06 11.36-21.35 3.11-1.21 3.7-2.94 3.7-5.69-.1-31.72-.09-57.43.02-80.93 0-1.75-.29-2.81-1-3.52-.86-.86-2.14-.98-3.41-.98h-.24c-5.77.07-11.71.11-17.65.11s-12.07-.04-18.22-.1h-.16c-1.18 0-2.4.11-3.22.95-.85.85-.95 2.15-.94 3.3.09 16.97.08 34.22.07 50.91v11.76c0 4.74-.92 5.64-5.74 5.65 0 0-10.38.01-13.36.01-4.99 0-9.98 0-14.97-.05-.72 0-1.56.04-2.3.37l-.29.14c-.78.44-1.35 1.13-1.84 2.2-2.65 5.85-8.15 9.48-14.37 9.48-1.51 0-3.03-.21-4.52-.63-7.3-2.06-11.95-9.07-11.31-17.03.59-7.45 6.78-13.41 14.71-14.15.43-.04.86-.06 1.29-.06 5.98 0 11.66 3.76 14.14 9.36.93 2.12 2.17 2.94 4.43 2.94h.19c3.75-.06 7.56-.08 11.32-.08s7.56.03 11.32.08h.25c1.02 0 2.07-.1 2.8-.83.76-.77.86-1.92.86-2.85-.1-18.93-.1-38.42 0-57.94 0-.87-.08-1.98-.81-2.71-.7-.71-1.73-.81-2.74-.81h-.14c-6.32.04-12.64.06-18.97.06s-12.44-.03-18.17-.08h-.14c-1.04 0-2.21.11-2.99.91-.79.81-.86 2.02-.83 3.1.15 5.32.1 10.75.06 15.99v1.6c-.04 3.8-1.14 4.91-4.92 4.94H55.3c-2.25.04-4.5.06-6.76.06-2.48 0-4.65-.03-6.64-.09h-.32c-2.22 0-3.52.83-4.65 2.97-2.3 4.37-6.88 7.08-11.94 7.08-1.2 0-2.39-.16-3.54-.46-5.75-1.54-10.01-6.97-10.12-12.92-.12-6.45 3.8-11.79 9.99-13.59 1.22-.36 2.49-.54 3.77-.54 5.07 0 9.63 2.75 11.9 7.18 1.07 2.08 2.39 2.93 4.56 2.93.15 0 .31 0 .47-.01 1.28-.06 2.62-.09 4.11-.09s3.08.03 4.62.08h.23c.61 0 1.49-.07 2.12-.71.65-.66.71-1.6.7-2.25-.07-3.91-.12-8.53.02-13.18.03-1-.2-1.72-.68-2.22-.71-.73-1.74-.74-2.66-.74h-.5c-1.37 0-2.74.02-4.11.04-1.36.02-2.72.04-4.08.04-2.6 0-6.01-.07-9.39-.64-16.32-2.71-28.2-14.1-31.79-30.47-.02-.08-.03-.16-.04-.24-.04-.33-.12-.93-.6-1.38v-10.52c.71-1.26.97-2.6 1.21-3.89.15-.79.29-1.54.53-2.24 3.78-11.28 11.09-19.18 21.72-23.48 4.2-1.7 6.77-4.3 8.35-8.44 8.81-23.06 30.45-37.95 55.13-37.95h.77c6.34 0 10.02-2.16 13.12-7.7C115.83 16.69 144.28 0 175.07 0c15.82 0 31.29 4.45 44.74 12.86.78.46 1.57.96 2.38 1.51.33.21.62.41.9.63 5.6 4.01 12 10.14 16.15 14.55.83.87 1.5 1.6 1.79 1.97 3.47 4.26 6.02 8 8.01 11.78 2.03 3.87 5.15 5.68 9.8 5.68h.33c.37-.01.74-.01 1.11-.01 28.02 0 53.33 20.61 58.88 47.93 3.14 15.47.32 31.29-7.94 44.52-8.27 13.25-21.26 22.74-36.59 26.73-3.72.97-4.94 2.59-4.65 6.21.26 3.26.18 6.63.1 9.89-.02.76-.04 1.52-.05 2.28-.01.76.05 1.71.69 2.36.45.45 1.07.67 1.9.67.13 0 .27 0 .41-.02.79-.06 1.59-.1 2.36-.1s1.48.03 2.2.09c.76.06 1.42.09 2.02.09 2.88 0 6.19-.6 8.87-5.05 1.99-3.3 5.62-5.19 9.98-5.19 1.91 0 3.86.39 5.63 1.13 5.62 2.34 8.9 7.89 8.34 14.12-.51 5.73-4.91 10.75-10.45 11.96-1.05.23-2.11.34-3.16.34-5.05 0-9.46-2.6-11.8-6.96-1.16-2.18-2.59-3.07-4.94-3.07h-.3c-2.12.07-4.39.1-6.95.1s-5-.03-7.5-.07c-3.51-.05-4.7-1.26-4.71-4.8v-.15c-.03-6.03-.07-12.27.03-18.41.01-.92-.06-1.86-.72-2.52-.66-.67-1.66-.76-2.45-.76-8.88.09-16.21.13-23.16.13-5.18 0-9.98-.02-14.69-.07h-.12c-.99 0-2.22.1-3.03.91-.76.76-.91 1.85-.9 3.25.09 18.33.09 36.96 0 56.98 0 1.37.14 2.44.88 3.18.77.77 1.89.87 2.78.87h.26c3.39-.08 6.89-.12 10.69-.12s7.53.04 11.94.11h.14c2.28 0 3.54-.83 4.49-2.96 2.59-5.74 8.06-9.31 14.27-9.31 1.67 0 3.33.27 4.95.79 7.51 2.44 12.18 10.11 10.86 17.85-1.28 7.5-7.98 13.16-15.58 13.16-.31 0-.63 0-.94-.03-6.33-.4-10.86-3.47-13.47-9.14-1.17-2.51-2.69-3.01-4.77-3.01h-.12c-4.11.04-8.62.06-14.19.06-2.82 0-14.14-.02-14.14-.02-4.42 0-5.43-1-5.44-5.32-.01-7 0-14 0-20.99v-10.49-8.61c-.02-7.6-.03-15.46.07-23.18.01-1.03-.07-2.32-.89-3.15-.55-.56-1.34-.83-2.41-.83-.25 0-.52.01-.81.04-.77.07-1.62.1-2.6.1-.92 0-1.84-.03-2.77-.06l-.8-.02c-.11 0-.2-.01-.3-.02l-.24-.02h-31.72l-.17.06c-.46.18-.83.4-1.12.7-1.67 1.66-1.37 4.28-1.08 6.81.11.95.21 1.85.21 2.67-.02 10.51-.02 21.02-.02 31.53 0 14.79 0 29.58-.05 44.36-.01 2.61.83 3.85 3.21 4.74 8.51 3.19 13.51 12.07 11.9 21.1-1.57 8.83-9.55 15.54-18.55 15.62h-.17zm-.11-30.72c-6.34.02-11.53 5.23-11.56 11.62-.02 3.14 1.17 6.07 3.35 8.26 2.18 2.2 5.12 3.4 8.27 3.4h.17c6.42-.08 11.42-5.23 11.37-11.72-.06-6.38-5.24-11.56-11.57-11.56h-.03zm101.39-36.56c-4.56 0-8.32 3.75-8.39 8.36-.03 2.3.83 4.47 2.44 6.1a8.291 8.291 0 005.93 2.49h.16c4.65-.08 8.27-3.81 8.25-8.5-.02-4.63-3.76-8.42-8.34-8.45h-.05zm-202.77 0c-4.44 0-8.17 3.65-8.32 8.14-.08 2.37.76 4.59 2.35 6.25 1.55 1.62 3.66 2.52 5.93 2.55 4.63 0 8.38-3.71 8.46-8.28.08-4.66-3.48-8.46-8.11-8.65h-.32zM25.05 187c-3.53 0-6.22 2.64-6.26 6.14a6.237 6.237 0 005.99 6.33h.27c3.44 0 6.28-2.77 6.32-6.18.05-3.35-2.67-6.17-6.07-6.29h-.25zm273.79 0c-3.49 0-6.16 2.62-6.22 6.1-.03 1.73.6 3.34 1.78 4.54 1.16 1.18 2.73 1.83 4.43 1.83 3.47-.03 6.18-2.73 6.24-6.13.06-3.47-2.49-6.19-5.93-6.33h-.29zm-65.12-24.01c7.55 0 15.1.01 22.64.04h.32c19.13 0 34.33-7.18 45.16-21.35 13.18-17.24 15.07-36.51 5.46-55.73-9.64-19.29-25.81-29.21-48.05-29.5-7.81-.09-13.04-3.02-16.48-9.2-1.95-3.52-4.33-7.03-7.49-11.05-5.07-7.05-11.75-11.8-16.16-14.94-.31-.19-.53-.34-.76-.5-.23-.16-.46-.32-.69-.46-14.22-8.62-28.62-12.99-42.79-12.99s-29.02 4.55-43.29 13.51c-10.54 6.62-18.72 15.55-24.32 26.55-3.98 7.83-9.81 11.33-18.89 11.33h-1.03c-22.17 0-40.9 13.02-48.89 33.99-2.12 5.57-5.64 9.18-11.08 11.36-13.72 5.51-21.81 18.83-19.67 32.38 2.32 14.75 14.13 25.36 29.39 26.4 1.56.11 3.22.16 5.1.16H211.84c7.29 0 14.58-.02 21.87-.02z"
                      />
                    </svg>
                  </div>
                  <div className="wdi-heading">Server Management</div>
                </div>
              </Link>
              <Link to="/cloud-computing/server-management-kindlebit">
                <div
                  className={
                    accuratePath ===
                      "/cloud-computing/server-management-kindlebit"
                      ? "item we-deals-list-inner active"
                      : "item we-deals-list-inner"
                  }
                  id="8"
                  onClick={() => setSubActive(0)}
                >
                  <div className="wdi-icon">
                    <svg
                      id="Layer_1"
                      data-name="Layer 1"
                      viewBox="0 0 320.42 298"
                    >
                      <path
                        d="M304.09 180.52c-1.77-.74-3.72-1.13-5.63-1.13-4.35 0-7.99 1.89-9.98 5.19-2.68 4.45-5.98 5.05-8.87 5.05-.6 0-1.26-.03-2.02-.09-.72-.06-1.46-.09-2.2-.09-.78 0-1.57.03-2.36.1-.15.01-.28.02-.41.02-.83 0-1.45-.22-1.9-.67-.64-.65-.71-1.6-.69-2.36.01-.76.03-1.52.05-2.28.08-3.26.16-6.63-.1-9.89-.29-3.61.93-5.24 4.65-6.21 15.32-3.98 28.32-13.47 36.59-26.73 8.26-13.24 11.08-29.05 7.94-44.52-5.55-27.33-30.87-47.93-58.88-47.93-.37 0-.74 0-1.11.01h-.33c-4.65 0-7.76-1.8-9.8-5.68-1.99-3.78-4.54-7.52-8.01-11.78-.3-.37-.97-1.1-1.79-1.97-4.14-4.41-10.55-10.54-16.15-14.55-.28-.22-.57-.42-.9-.63-.81-.55-1.6-1.06-2.38-1.51C206.36 4.45 190.89 0 175.07 0c-30.79 0-59.24 16.69-74.24 43.56-3.1 5.54-6.78 7.7-13.12 7.7h-.77c-24.67 0-46.31 14.89-55.13 37.95-1.58 4.14-4.16 6.74-8.35 8.44-10.63 4.3-17.94 12.2-21.72 23.48-.24.71-.38 1.46-.53 2.24-.25 1.3-.5 2.63-1.21 3.9v10.52c.47.45.55 1.05.6 1.38.01.08.02.16.04.24 3.59 16.36 15.47 27.75 31.79 30.47 3.38.57 6.79.64 9.39.64 1.36 0 2.72-.02 4.08-.04 1.37-.02 2.74-.04 4.11-.04h.5c.91 0 1.95.01 2.66.74.48.5.7 1.22.68 2.22-.13 4.65-.08 9.27-.02 13.18.01.65-.05 1.59-.7 2.25-.63.64-1.51.72-2.12.72h-.23c-1.54-.05-3.08-.08-4.62-.08s-2.84.03-4.11.09c-.16 0-.32.01-.47.01-2.17 0-3.49-.85-4.56-2.93-2.27-4.43-6.83-7.18-11.9-7.18-1.28 0-2.55.18-3.77.54-6.19 1.81-10.11 7.14-9.99 13.59.11 5.95 4.36 11.38 10.12 12.92 1.16.31 2.35.46 3.54.46 5.06 0 9.64-2.71 11.94-7.08 1.13-2.14 2.43-2.97 4.65-2.97h.32c1.99.06 4.16.09 6.64.09 2.25 0 4.51-.02 6.76-.05h1.04c3.77-.05 4.87-1.16 4.9-4.95v-1.6c.06-5.25.11-10.67-.04-15.99-.03-1.08.04-2.29.83-3.1.78-.81 1.95-.91 2.99-.91h.14c5.73.06 11.68.08 18.17.08s12.65-.03 18.97-.06h.14c1.01 0 2.04.1 2.74.81.73.73.81 1.83.81 2.71-.09 19.51-.09 39.01 0 57.94 0 .92-.09 2.08-.86 2.85-.73.73-1.78.84-2.8.84h-.25c-3.75-.06-7.56-.08-11.32-.08s-7.57.03-11.32.08h-.19c-2.26 0-3.51-.83-4.43-2.94-2.48-5.6-8.16-9.36-14.14-9.36-.43 0-.86.02-1.29.06-7.93.75-14.12 6.7-14.71 14.15-.64 7.96 4.01 14.96 11.31 17.03 1.49.42 3.01.63 4.52.63 6.22 0 11.72-3.63 14.37-9.48.49-1.07 1.06-1.76 1.84-2.2l.29-.14c.74-.33 1.57-.37 2.3-.37 4.99.04 9.98.05 14.97.05 2.98 0 13.36-.01 13.36-.01 4.83 0 5.74-.91 5.74-5.65v-11.76c.02-16.68.03-33.94-.06-50.91 0-1.16.1-2.45.94-3.3.83-.83 2.04-.95 3.22-.95h.16a1607.231 1607.231 0 0035.87 0h.24c1.26 0 2.55.12 3.41.98.71.71 1.01 1.77 1 3.52-.12 23.5-.12 49.21-.02 80.93 0 2.75-.59 4.47-3.7 5.69-8.42 3.29-13.2 12.27-11.36 21.35 1.77 8.77 9.67 15.13 18.79 15.13h.17c9.01-.08 16.98-6.8 18.55-15.62 1.61-9.03-3.4-17.91-11.9-21.1-2.38-.9-3.22-2.14-3.21-4.74.04-14.79.05-29.58.05-44.36 0-10.51 0-21.02.02-31.53 0-.82-.1-1.72-.21-2.67-.29-2.53-.58-5.15 1.08-6.81.29-.29.66-.52 1.12-.7l.17-.07h31.72l.24.03c.1 0 .19.02.3.02l.8.02c.92.03 1.84.06 2.77.06.98 0 1.83-.03 2.6-.1.29-.03.56-.04.81-.04 1.07 0 1.86.27 2.41.83.82.83.91 2.12.89 3.15-.1 7.72-.09 15.58-.07 23.18 0 2.87.01 5.74.01 8.61v10.49c0 7-.01 13.99 0 20.99 0 4.32 1.02 5.32 5.44 5.32 0 0 11.31.02 14.14.02 5.58 0 10.09-.02 14.19-.06h.12c2.08 0 3.6.5 4.77 3.01 2.61 5.67 7.15 8.75 13.47 9.14.32.02.63.03.94.03 7.6 0 14.29-5.66 15.58-13.16 1.32-7.74-3.35-15.42-10.86-17.85-1.62-.52-3.28-.79-4.95-.79-6.21 0-11.67 3.57-14.27 9.31-.96 2.13-2.22 2.96-4.49 2.96h-.14c-4.41-.08-8.32-.11-11.94-.11-3.8 0-7.3.04-10.69.12h-.26c-.89 0-2.01-.1-2.78-.86-.74-.74-.88-1.8-.88-3.18.09-20.01.09-38.65 0-56.98 0-1.4.14-2.49.9-3.25.81-.81 2.04-.92 3.03-.92h.12c4.71.05 9.52.07 14.69.07 6.95 0 14.28-.04 23.16-.13.79 0 1.79.09 2.45.76.66.67.73 1.6.72 2.52-.09 6.13-.06 12.37-.03 18.41v.15c.02 3.53 1.21 4.74 4.71 4.8 2.5.04 5 .07 7.5.07s4.83-.03 6.95-.1h.3c2.35 0 3.78.88 4.94 3.06 2.34 4.36 6.75 6.96 11.8 6.96 1.05 0 2.11-.12 3.16-.34 5.55-1.2 9.94-6.23 10.45-11.96.55-6.24-2.72-11.78-8.34-14.12zM25.03 199.47h-.27a6.237 6.237 0 01-5.99-6.33c.04-3.5 2.73-6.14 6.26-6.14h.25c3.39.12 6.12 2.95 6.07 6.3-.05 3.41-2.89 6.18-6.32 6.18zm35.3 48.19a8.246 8.246 0 01-5.93-2.55c-1.59-1.66-2.43-3.88-2.35-6.25.15-4.49 3.88-8.14 8.32-8.14h.32c4.62.19 8.18 3.99 8.11 8.65-.08 4.57-3.83 8.28-8.46 8.28zm202.8-16.94h.05c4.58.03 8.32 3.82 8.34 8.45.02 4.69-3.61 8.42-8.25 8.5h-.16a8.25 8.25 0 01-5.93-2.49c-1.61-1.63-2.47-3.79-2.44-6.1.07-4.61 3.83-8.36 8.39-8.36zm-89.79 48.12c.05 6.49-4.95 11.63-11.37 11.71h-.17c-3.15 0-6.08-1.21-8.27-3.4-2.18-2.19-3.37-5.12-3.35-8.26.04-6.39 5.22-11.6 11.56-11.62h.03c6.32 0 11.51 5.19 11.57 11.56zm83.32-115.81h-.32c-7.55-.03-15.09-.04-22.64-.04s-14.58 0-21.87.02H42.19c-1.88 0-3.55-.05-5.1-.16-15.26-1.04-27.07-11.65-29.39-26.4-2.14-13.55 5.95-26.87 19.67-32.38 5.44-2.18 8.96-5.79 11.08-11.36 7.99-20.97 26.72-34 48.89-34h1.03c9.08 0 14.91-3.49 18.89-11.32 5.6-11 13.78-19.94 24.32-26.55 14.27-8.97 28.83-13.51 43.29-13.51s28.57 4.37 42.79 12.99c.23.14.46.3.69.46.22.15.44.31.76.5 4.42 3.14 11.09 7.89 16.16 14.94 3.16 4.02 5.54 7.53 7.49 11.05 3.44 6.18 8.67 9.11 16.48 9.2 22.24.29 38.41 10.21 48.05 29.5 9.61 19.22 7.72 38.49-5.46 55.73-10.83 14.17-26.03 21.35-45.16 21.35zm42.15 36.44c-1.69 0-3.27-.65-4.43-1.83-1.18-1.2-1.81-2.81-1.78-4.54.06-3.48 2.73-6.1 6.22-6.1h.29c3.44.14 5.99 2.86 5.93 6.33-.06 3.41-2.77 6.1-6.24 6.13z"
                        className="cls-1"
                      />
                      <path
                        d="M72.94 123.67a10.18 10.18 0 00-1.77-2.37c-.71-.71-1.61-1.27-2.71-1.66-1.1-.4-2.47-.58-4.12-.55v-.55c1.34-.6 2.62-1.37 3.86-2.33 1.24-.95 2.39-2.04 3.46-3.26 1.07-1.22 1.97-2.52 2.71-3.9s1.28-2.75 1.62-4.12H68.1c-.26 1.17-.68 2.35-1.28 3.54s-1.34 2.34-2.24 3.43c-.9 1.1-1.92 2.11-3.07 3.03-1.15.92-2.42 1.69-3.82 2.28v-12.29h-6.87v28.16h6.87v-10.62h2.47c1.73 0 3.06.23 3.97.68.91.46 1.58 1.07 2.01 1.86.43.78.78 1.67 1.07 2.67l1.49 5.42h7.76l-2.35-6.74c-.31-.91-.7-1.8-1.17-2.67zM81.24 104.92h6.95v28.16h-6.95zM116.01 123.86h-.42l-11.69-18.94h-8.96v28.16h6.7l-.35-19.93h.43l12.5 19.93h8.19v-28.16h-6.74l.34 18.94zM147.65 106.58c-2.2-1.11-5.03-1.66-8.47-1.66h-10.07v28.16h11.35c1.28 0 2.56-.14 3.84-.43 1.28-.28 2.5-.76 3.67-1.43 1.17-.67 2.2-1.55 3.11-2.65.91-1.09 1.63-2.45 2.16-4.07.53-1.62.79-3.54.79-5.76 0-2.87-.51-5.34-1.54-7.4-1.02-2.06-2.64-3.65-4.84-4.76zm-1.3 16.62c-.34 1.1-.82 1.95-1.45 2.56-.63.61-1.33 1.05-2.11 1.32-.78.27-1.63.41-2.54.41h-4.27v-16.98h3.46c1.17 0 2.21.15 3.14.45.92.3 1.71.78 2.35 1.45.64.67 1.12 1.55 1.45 2.65.33 1.09.49 2.44.49 4.03s-.17 3.02-.51 4.12zM166.57 104.92h-6.87v28.16h18.18v-5.8h-11.31v-22.36zM189.18 121.39h12.89v-4.99h-12.89v-5.93h14.89v-5.55h-21.8v28.16h21.93v-5.59h-15.02v-6.1zM232.27 121.07c-1.31-1.15-3.34-1.81-6.1-1.98v-.64c1.65-.17 2.98-.52 3.99-1.04s1.75-1.21 2.22-2.05c.47-.84.7-1.8.7-2.88 0-1.31-.26-2.44-.79-3.39a6.43 6.43 0 00-2.26-2.35c-.98-.61-2.18-1.07-3.58-1.37-1.41-.3-2.98-.45-4.71-.45h-11.99v28.16h13.06c2.48 0 4.56-.28 6.25-.83 1.69-.55 2.98-1.37 3.86-2.45.88-1.08 1.32-2.45 1.32-4.1 0-1.93-.66-3.48-1.96-4.63zm-15.91-10.73h5.03c.6 0 1.19.04 1.77.13.58.09 1.12.23 1.6.45.48.21.87.53 1.15.94.28.41.43.93.43 1.56 0 .68-.16 1.24-.47 1.69-.31.44-.75.77-1.3 1-.55.23-1.18.38-1.88.47-.7.09-1.43.13-2.2.13h-4.14v-6.36zm10.71 15.77c-.28.41-.67.72-1.15.94s-1.02.36-1.6.45c-.58.08-1.16.13-1.73.13h-6.23v-6.61h5.21c.6 0 1.18.03 1.75.09.57.06 1.1.16 1.6.32s.94.36 1.32.62c.38.25.69.58.92.98.23.4.34.9.34 1.49 0 .65-.14 1.19-.43 1.6zM239.87 104.92h6.95v28.16h-6.95zM259.45 104.92h-7.93v5.76h7.93v22.4h6.91v-22.4h8.02v-5.76h-14.93z"
                        className="cls-1"
                      />
                    </svg>
                  </div>
                  <div className="wdi-heading">
                    Server management with Kindlebit
                  </div>
                </div>
              </Link>
              <Link to="/cloud-computing/database-management">
                <div
                  className={
                    accuratePath === "/backup-management" ||
                      accuratePath === "/cloud-computing/database-management"
                      ? "item we-deals-list-inner active"
                      : "item we-deals-list-inner"
                  }
                  id="8"
                  onClick={() => setSubActive(0)}
                >
                  <div className="wdi-icon">
                    <svg data-name="Layer 1" viewBox="0 0 300 196.26">
                      <path
                        fill="#9cb5d4"
                        d="M217.1 196.26c-14.99 0-30.96-.06-48.83-.18-16.94-.12-31.46-12.22-35.31-29.43-3.65-16.31 4.73-33.53 19.91-40.93 1.65-.81 2.83-1.81 3.24-4.1 2.5-14.21 13-23.4 26.76-23.4 2.15 0 4.36.23 6.56.69.37.08.7.12 1.01.12 1.75 0 2.41-1.21 2.95-2.19l.13-.24c8.25-14.82 20.68-22.33 36.97-22.33h.8c11.33.17 21.83 4.97 29.56 13.53 7.8 8.63 11.7 20.19 10.71 31.72l-.22 2.46.61.31c1.32.67 2.64 1.3 3.95 1.92 2.85 1.35 5.54 2.62 8 4.27 8.13 5.44 13.33 13.39 15.46 23.61.14.65.29 1.3.45 1.95l.19.78v8.55c-.54 1.52-1.02 3.09-1.49 4.6-1.04 3.37-2.11 6.86-3.84 9.84-6.85 11.79-17.52 18.09-30.87 18.22-14.84.15-30.11.22-46.7.22zm-1.28-7.51c4.82 0 9.63 0 14.45.02 4.82 0 9.64.02 14.45.02 7.04 0 12.84-.02 18.27-.07 8.57-.08 16.66-3.8 22.21-10.22 5.58-6.46 8.11-15.08 6.93-23.65-1.8-13.04-11.37-22.72-24.97-25.26-1.81-.34-2.96-.91-3.53-1.74-.57-.84-.67-2.09-.32-3.94.42-2.15.84-4.35.92-6.56.58-17.2-10.98-31.96-27.49-35.09-2.24-.42-4.5-.64-6.72-.64-14.53 0-26.77 8.84-31.95 23.07-1.15 3.16-2.44 3.58-3.54 3.58-.82 0-1.82-.27-3.04-.82-2.81-1.26-5.71-1.9-8.65-1.9-5.25 0-10.17 2.05-13.85 5.76-3.78 3.82-5.82 9.04-5.76 14.71.03 2.52-.9 3.86-3.31 4.77-14.73 5.56-22.48 18.88-19.76 33.93 2.56 14.13 15.12 24.01 30.56 24.02h45.09zm-87.47 7.42H14.63c-9.27 0-14.59-5.29-14.6-14.51-.01-8.55-.01-17.1 0-25.65.01-9 5.39-14.4 14.39-14.43h4.33v-16.19h-4.67c-8.5-.05-14.01-5.51-14.04-13.9-.03-8.95-.03-17.97 0-26.83.03-8.23 5.56-13.8 13.77-13.87h5.1V54.6h-4.02c-.55.01-1.1 0-1.65 0C5.66 54.43.12 48.85.06 41.32c-.07-9.14-.07-18.56 0-28C.12 5.62 5.76.03 13.48.02 43.78.01 74.1 0 104.4 0s61.67 0 92.51.02c7.86 0 13.37 5.6 13.42 13.6.05 8.09.05 16.96 0 27.12-.03 8.21-5.58 13.78-13.8 13.85h-4.91v16.19h1.02c.47 0 .94 0 1.41-.01.47 0 .93-.01 1.4-.01.56 0 1.11 0 1.67.04 2.24.14 3.75 1.61 3.76 3.66 0 2.04-1.5 3.53-3.75 3.7-.39.03-.78.04-1.18.04-.28 0-1.41-.02-1.7-.02H15.55c-6.37 0-8.11 1.74-8.11 8.08v24.18c0 5.62 1.89 7.52 7.49 7.52h116.53c.35 0 .71 0 1.06.03 2.26.15 3.81 1.6 3.85 3.62.04 2.08-1.59 3.63-3.97 3.76-.35.02-.7.02-1.05.02h-1.55l-103.37-.01v16.19h90.31c.24 0 1.1-.01 1.31-.01.52 0 1.12.02 1.65.16 1.86.5 2.77 1.65 2.78 3.51.01 1.95-.96 3.14-2.96 3.64-.37.09-.79.13-1.38.13-.26 0-.52 0-.78-.01-.28 0-.55-.01-.83-.01H15.39c-6.17 0-7.95 1.78-7.95 7.94v24.48c0 5.36 2 7.36 7.35 7.36h113.47c.49 0 1.05.02 1.56.16 1.96.53 2.88 1.76 2.8 3.74-.07 1.83-1.03 2.94-2.93 3.41-.45.11-.95.12-1.34.12zM26.46 70.63h157.47V54.81H26.46v15.82zM14.65 7.42c-5.18 0-7.2 2.02-7.21 7.2-.01 8.55-.02 17.11 0 25.66.01 4.78 2.14 6.91 6.91 6.91h181.66c4.77 0 6.9-2.13 6.91-6.91.02-6.87.01-13.74 0-20.62V15.2c0-5.97-1.83-7.79-7.8-7.79H14.65zm99.08 165.16H107.92c-.97 0-4.69.02-5.63.02-1.18 0-2.36 0-3.55-.03-2.63-.05-4.28-1.45-4.3-3.67-.02-2.26 1.6-3.68 4.22-3.71 3.15-.03 6.29-.04 9.44-.04s6.24.01 9.36.04c1.32.01 2.46.44 3.2 1.22.64.67.97 1.55.94 2.55-.06 2.13-1.66 3.55-4.09 3.6-1.26.03-2.52.04-3.78.04zm-91.12-.04c-1.94 0-3.62-1.65-3.67-3.59-.03-.97.34-1.9 1.02-2.62s1.59-1.13 2.56-1.16c2.07 0 3.72 1.61 3.77 3.59.03.96-.34 1.89-1.03 2.61s-1.6 1.14-2.56 1.16h-.1zm14.15 0c-1.96 0-3.64-1.66-3.67-3.62-.04-1.99 1.62-3.7 3.61-3.74 2.02 0 3.71 1.65 3.74 3.61.02.96-.35 1.89-1.05 2.6-.69.72-1.61 1.12-2.57 1.14h-.07zm14.15 0c-.97 0-1.89-.39-2.59-1.1-.7-.7-1.09-1.63-1.08-2.59 0-1.99 1.69-3.67 3.67-3.67.98 0 1.9.39 2.6 1.09s1.09 1.62 1.08 2.59c0 1.99-1.69 3.67-3.68 3.67zm47.99-70.75c-3.03 0-3.71-1.2-3.96-2.1-.35-1.28-.2-3.02.33-3.66.7-.84 2.4-1.55 3.79-1.58 3.55-.08 7.34-.11 12.27-.11 2.17 0 4.34 0 6.51.01 2.17 0 4.34.01 6.51.01h25.02c2.22 0 4.87.64 4.92 3.63.02 1.03-.28 1.87-.9 2.5-.81.83-2.15 1.27-3.86 1.27H98.91zm-48.09-.03c-2-.06-3.63-1.8-3.57-3.79.06-1.97 1.71-3.57 3.67-3.57h.11c.97.03 1.88.45 2.56 1.17.68.72 1.04 1.65 1.01 2.61-.06 1.94-1.74 3.58-3.68 3.58h-.11zm-14.09 0c-2-.02-3.66-1.73-3.64-3.72a3.686 3.686 0 013.67-3.64c1.01.01 1.92.41 2.62 1.12.7.71 1.07 1.63 1.06 2.6-.02 1.98-1.71 3.64-3.68 3.64h-.04zm-14.13 0c-1.99 0-3.67-1.7-3.67-3.69s1.69-3.67 3.68-3.67c.98 0 1.9.39 2.6 1.1.7.7 1.08 1.62 1.08 2.59 0 1.99-1.69 3.67-3.68 3.67h-.01zm76.18-70.74c-.46 0-.8-.03-1.1-.09-2.15-.43-3.23-1.67-3.2-3.69.03-2.01 1.14-3.22 3.3-3.61.26-.05.54-.07.93-.07h.6c.22 0 .43.01.65.01h87.06c.24 0 .49 0 .73.02 2.25.19 3.74 1.69 3.71 3.73-.03 2.05-1.53 3.48-3.82 3.64-.31.02-.62.03-.93.03h-1.36l-85.22-.01c-.23 0-.46 0-.7.01-.22 0-.43.01-.65.01zm-62.08-.04c-.97-.02-1.88-.43-2.57-1.15s-1.06-1.65-1.03-2.61c.04-1.99 1.69-3.6 3.67-3.6 1.05.02 1.96.43 2.65 1.15s1.06 1.64 1.04 2.61c-.04 1.96-1.73 3.61-3.68 3.61h-.08zm-14.08 0c-1.96 0-3.64-1.66-3.67-3.62-.02-.97.35-1.89 1.04-2.61.69-.71 1.6-1.12 2.57-1.13 2.02 0 3.71 1.66 3.74 3.62.03 1.99-1.62 3.71-3.62 3.74h-.06zm28.26 0c-2-.03-3.66-1.74-3.63-3.73.03-2 1.68-3.63 3.67-3.63 1.02.01 1.94.41 2.63 1.13.69.71 1.07 1.64 1.05 2.6-.03 1.97-1.71 3.63-3.68 3.63h-.05z"
                      />
                    </svg>
                  </div>
                  <div className="wdi-heading">Database Management</div>
                </div>
              </Link>
              <Link to="/cloud-computing/iaas">
                <div
                  className={
                    accuratePath === "/cloud-computing/iaas"
                      ? "item we-deals-list-inner active"
                      : "item we-deals-list-inner"
                  }
                  id="8"
                  onClick={() => setSubActive(0)}
                >
                  <div className="wdi-icon">
                    <svg data-name="Layer 1" viewBox="0 0 300 300.12">
                      <path
                        fill="#9cb5d4"
                        d="M155.44 300.12c-.83 0-1.73-.03-2.68-.09-1.02-.06-2.11-.09-3.43-.09-.93 0-1.86.01-2.79.03-.92.01-1.84.03-2.76.03h-.83c-4.02-.05-9.11-1.44-10.53-7.81-1.22-5.5-3.92-8.29-9.32-9.6-3.81-.93-7.51-2.89-11.09-4.79l-.71-.38c-1.28-.68-2.38-1-3.44-1-1.17 0-2.29.39-3.44 1.19-.77.54-1.64.97-2.56 1.42l-.62.3c-1.92.96-3.76 1.45-5.48 1.45-2.63 0-5.05-1.1-7.39-3.37-3.21-3.1-6.32-6.24-10-9.99-4.35-4.42-4.98-8.7-1.99-13.46 2.81-4.48 2.86-8.18.15-12.78-1.4-2.38-2.33-5.01-3.31-7.78-.6-1.7-1.23-3.46-1.96-5.14-.66-1.5-2.08-3.29-3.66-3.69-11.04-2.78-12.65-6.47-12.17-16.87.09-1.96.07-3.94.05-5.86-.01-1.21-.03-2.41-.01-3.62.04-3.99 1.44-9.04 7.83-10.5 5.34-1.22 8.06-3.86 9.39-9.13.7-2.76 1.97-5.35 3.32-8.09.8-1.62 1.62-3.3 2.31-5.01.6-1.5.4-3.42 0-4.7-.34-1.12-.93-2.11-1.49-3.07-.3-.51-.6-1.02-.86-1.55-2.18-4.44-1.58-8.63 1.74-12.1l.93-.97c3.24-3.41 6.59-6.93 10.17-10.01 1.32-1.14 3.03-1.92 4.84-2.76.71-.33 1.44-.66 2.17-1.03.88.39 1.73.75 2.57 1.11 2.14.91 4.17 1.77 6.02 2.83 1.14.65 2.23.97 3.31.97s2.11-.28 3.45-.91c5.34-2.5 10.57-4.67 15.53-6.44 2.08-.74 4.08-1.86 4.68-5.01.25-1.29.68-2.54 1.22-4.03 1.61-4.44 5.07-6.93 9.72-6.99 2.4-.03 4.79-.05 7.19-.05 2.63 0 5.26.02 7.89.04 3.93.03 8.9 1.39 10.3 7.64 1.22 5.46 3.93 8.23 9.33 9.58 2.67.66 5.17 1.9 7.81 3.2 1.62.8 3.29 1.62 5 2.3.67.27 1.46.4 2.33.4s1.78-.13 2.63-.39c1.1-.33 2.07-.9 3.01-1.44.64-.37 1.24-.72 1.86-.99 1.68-.73 3.3-1.1 4.82-1.1 2.4 0 4.61.93 6.57 2.76 3.79 3.55 7.57 7.31 11.53 11.51 3.47 3.67 4 8.03 1.46 11.96-3.08 4.77-3.11 8.94-.1 13.95 1.79 2.98 2.93 6.5 4.03 9.9.26.81.52 1.62.79 2.42.6 1.78 1.51 3.5 4.1 3.99 1.34.26 2.7.75 4.02 1.23l.61.22c4.62 1.66 7.09 5.09 7.15 9.93.06 4.81.06 9.74 0 15.08-.06 5.48-2.72 9.06-7.48 10.09-5.59 1.21-8.58 4.13-9.97 9.78-.87 3.53-2.68 6.96-4.42 10.27l-.79 1.52c-1.26 2.42-1.21 4.31.17 6.3.46.66.83 1.39 1.23 2.17l.38.73c2.8 5.33 2.24 9.41-1.88 13.64-3.17 3.26-6.53 6.61-9.99 9.99-2.46 2.4-5 3.61-7.54 3.61-1.76 0-3.58-.58-5.43-1.73-2.47-1.54-4.63-2.26-6.8-2.26s-4.19.67-6.56 2.1c-2.3 1.4-4.89 2.29-7.62 3.24-1.66.57-3.37 1.17-5.01 1.88-1.48.65-3.26 2.06-3.68 3.64-2.23 8.49-4.21 12.21-13.84 12.21zm-47.52-31.75c1.98 0 4.02.54 6.24 1.64 4.97 2.47 10.17 4.63 15.46 6.42 5.14 1.74 7.88 4.5 8.87 8.97.14.64.35 1.25.55 1.85.2.6.4 1.18.51 1.75.43 2.12 1.72 3.15 3.92 3.15h.29c1.2-.05 2.4-.06 3.59-.06.82 0 1.64 0 2.45.01.82 0 1.65.01 2.47.01.51 0 2.17-.01 2.17-.01.53 0 .99 0 1.4.01h.9c3.06 0 3.33-1.11 4.04-4.08.12-.49.25-1.05.42-1.7 1.41-5.53 4.52-8.65 10.07-10.12 3.74-.99 8.05-2.32 11.64-4.64 3.29-2.13 6.33-3.16 9.31-3.16s5.96 1.06 8.98 3.25c.54.39 1.13.63 1.75.89.27.11.55.22.83.36l.61.29.53-.43c.2-.16.4-.32.6-.47.46-.36.94-.73 1.38-1.16 2.08-2.04 4.3-4.23 6.47-6.47.72-.74 1.33-1.33 1.83-1.81 2.85-2.74 2.75-3.36.65-6.92-.31-.52-.66-1.12-1.06-1.83-2.43-4.29-2.46-8.29-.08-12.96 2.36-4.65 4.46-9.71 6.43-15.47 1.71-5.02 4.42-7.68 8.78-8.65.54-.12 1.03-.3 1.51-.48.5-.19.97-.36 1.42-.43 2.82-.46 4.1-2.09 3.91-5-.13-1.99-.1-4.05-.08-6.04.02-1.11.03-2.22.02-3.33v-1.95c.05-3.77-.29-4.2-4-5.1-.49-.12-1.05-.26-1.7-.42-5.41-1.41-8.54-4.53-10.15-10.1a66.804 66.804 0 00-5.72-13.81c-2.95-5.34-2.93-9.72.05-14.23.26-.4.47-.8.66-1.19.18-.36.35-.7.55-1 1.34-1.99 1.09-3.85-.74-5.52-1.31-1.19-2.58-2.49-3.81-3.74-.8-.82-1.6-1.64-2.42-2.43-.75-.73-1.35-1.35-1.85-1.86-1.53-1.57-2.3-2.36-3.51-2.36-.91 0-1.71.47-3.17 1.33-.6.36-1.34.79-2.25 1.29-2.25 1.23-4.35 1.83-6.41 1.83-1.71 0-3.4-.4-5.19-1.23-5.99-2.77-12.18-5.23-17.99-7.49-3.83-1.49-6.11-3.8-7.19-7.28-.16-.51-.28-1.03-.41-1.56-.28-1.15-.57-2.34-1.16-3.42-.66-1.21-2.22-2.54-3.67-2.65-1.42-.11-2.96-.16-4.83-.16-1.17 0-2.34.02-3.51.04l-1.82.03h-2.13c-.34 0-.65-.01-.92-.01-3.1 0-3.39 1.17-4.16 4.28-.12.48-.25 1.02-.41 1.64-1.32 5.06-4.31 8.1-9.7 9.84-5.46 1.77-10.78 4.21-15.72 6.6-2.06 1-3.95 1.48-5.77 1.48s-3.66-.51-5.48-1.57c-.37-.22-.76-.41-1.16-.6-.55-.27-1.07-.52-1.5-.84-1.17-.86-2.24-1.28-3.28-1.28-1.36 0-2.62.71-3.83 2.17-1.18 1.42-2.56 2.74-3.89 4.02-.75.72-1.5 1.44-2.23 2.18-.59.61-1.11 1.1-1.53 1.52-2.73 2.64-2.64 3.23-.62 6.61.25.42.53.89.85 1.44 2.68 4.62 2.72 8.87.13 13.77-2.76 5.21-4.77 10.77-6.37 15.51-1.55 4.59-4.22 7.22-8.4 8.29-.62.16-1.23.35-1.84.55-.71.22-1.37.44-2.05.59-2.2.51-3.22 1.89-3.13 4.24.07 1.78.06 3.61.04 5.37-.01 1.24-.02 2.48 0 3.72.02 1.06 0 1.93 0 2.65-.06 3.89.28 4.33 3.98 5.25.65.16 1.44.36 2.39.62 4.88 1.36 7.76 4.25 9.33 9.38 1.21 3.95 2.93 9.05 5.52 13.56 3.37 5.86 3.35 10.66-.05 15.59l-.15.22c-.44.63-.99 1.41-1.01 2.31v.17c-.03 1.32-.07 2.97.81 4.04 1.58 1.91 3.38 3.64 5.13 5.31l1.11 1.07c.85.82 1.51 1.5 2.06 2.06 1.48 1.52 2.3 2.36 3.54 2.36.95 0 1.82-.51 3.39-1.43.63-.37 1.38-.81 2.32-1.32 2.12-1.16 4.13-1.73 6.17-1.73zm41.85-13.69c-27.05-.11-49.02-22.28-48.97-49.42.05-27.08 22.2-49.12 49.38-49.12h.19c27.06.1 49.02 22.27 48.97 49.41-.05 27.09-22.2 49.13-49.37 49.13h-.2zm.23-90.64c-22.77.03-41.29 18.58-41.29 41.36 0 11.02 4.32 21.4 12.17 29.23 7.84 7.83 18.24 12.14 29.27 12.14h.16c22.73-.09 41.18-18.72 41.13-41.52-.05-22.72-18.62-41.21-41.39-41.21H150zm109.08 28.51c-1.13 0-2.02-.42-2.75-1.28-.75-.9-1.05-1.99-.84-3.06.26-1.33 1.28-2.54 2.78-3.32 8.91-4.66 15.74-10.27 20.86-17.15 14.35-19.27 17.11-39.9 8.22-61.32-8.91-21.45-25.46-34.09-49.18-37.54-2.34-.34-4.79-.52-7.26-.52-4.27 0-8.76.5-13.74 1.53-.68.14-1.3.21-1.85.21-1.7 0-3.5-.53-3.88-4.45-2.46-25.18-15.04-42.94-37.37-52.77-7.66-3.37-15.73-5.08-24.01-5.08-30.89 0-57.67 24.01-60.97 54.66-.01.14-.04.28-.06.41a6 6 0 00-.1.94c-.04 5.18-1.66 6.17-4.62 6.17-.97 0-2.1-.13-3.45-.4-3.94-.78-7.94-1.18-11.89-1.18-17.27 0-33.87 7.56-45.54 20.74C11.83 102.25 6.38 119.69 8.5 137c2.53 20.74 13.35 36.64 32.15 47.25 1.48.84 3.22 2.37 3.77 3.91.28.8-.55 3.03-1.29 3.46-.62.36-1.6.58-2.61.58-.82 0-1.6-.15-2.13-.41-11.94-5.8-21.42-14.45-28.19-25.71-12.19-20.29-13.52-44.13-3.63-65.4 9.89-21.28 28.98-35.65 52.38-39.42 2.97-.48 6.2-.71 10.49-.75h.46c2.18 0 4.36.15 6.67.32 1.11.08 2.23.16 3.38.22l1.01.06.13-1c2.07-16.54 10.34-31.8 23.29-42.96C117.17 6.08 133.37 0 149.98 0c.68 0 1.36 0 2.03.03 33.9 1.01 62.68 26.88 66.96 60.16l.13 1.04 1.04-.1c.64-.06 1.28-.13 1.92-.19 1.37-.14 2.79-.29 4.18-.38 1.5-.1 3.01-.15 4.51-.15 35.26 0 64.83 26.49 68.78 61.63 3.25 28.89-11.32 56.19-37.11 69.54-1.25.64-2.38.97-3.37.97z"
                      />
                    </svg>
                  </div>
                  <div className="wdi-heading">IaaS</div>
                </div>
              </Link>
              <Link to="/cloud-computing/paas">
                <div
                  className={
                    accuratePath === "/cloud-computing/paas"
                      ? "item we-deals-list-inner active"
                      : "item we-deals-list-inner"
                  }
                  id="8"
                  onClick={() => setSubActive(0)}
                >
                  <div className="wdi-icon">
                    <svg data-name="Layer 1" viewBox="0 0 300 300.11">
                      <path
                        fill="#9cb5d4"
                        d="M195.79 300.11c-3.06 0-6.1-.06-9.02-.17-3.82-.15-6.72-2.26-8.38-6.1-.73-1.68-1.41-3.42-2.07-5.1-.86-2.19-1.75-4.46-2.76-6.64-.62-1.34-1.99-2.68-3.42-3.32a274.41 274.41 0 00-15.28-6.31c-.81-.31-1.78-.47-2.74-.47-.83 0-1.62.13-2.29.37-2.81 1.01-5.59 2.23-8.27 3.41-.98.43-1.95.86-2.93 1.28-1.57.67-3.09 1.01-4.52 1.01-2.43 0-4.67-.98-6.63-2.92-2.4-2.36-4.76-4.86-7.04-7.28-2.02-2.14-4.12-4.36-6.24-6.49-.97-.97-2.68-1.32-3.95-1.32-1.65.02-3.2.03-4.74.03-22.29 0-42.23-2.26-60.95-6.92-13.52-3.36-23.31-7.35-31.75-12.93-6.63-4.39-10.82-9.73-12.79-16.33V36.34c1.84-6.65 5.98-12 12.66-16.35 2.32-1.51 5.1-3.25 8.03-4.64C40.22 6.06 61.26 2.98 79.26 1.2c2.98-.3 5.97-.56 8.96-.82L92.4.01h24.72l4.22.38c2.96.26 5.91.52 8.87.8 16.83 1.58 36.51 4.31 54.94 12.5 5.23 2.33 10.72 5.72 16.76 10.35 5.25 4.02 7.86 9.85 7.76 17.31-.2 15.9-.1 32.07 0 47.71v1.05c.01 1.36.59 2.62 1.15 3.83.12.26.24.53.35.79.69 1.6 1.41 3.19 2.12 4.77 1.28 2.83 2.6 5.75 3.71 8.67 1.06 2.77 2.77 3.88 5.01 4.69 2.76 1 5.52 2.2 8.19 3.35 2.02.87 4.11 1.78 6.2 2.6.81.32 1.75.49 2.64.49.69 0 1.3-.1 1.84-.3 2.55-.95 5.09-2.06 7.53-3.13 1.3-.57 2.6-1.14 3.91-1.69 1.61-.68 3.17-1.02 4.63-1.02 2.41 0 4.64.94 6.6 2.8 4.33 4.09 8.13 7.9 11.62 11.65 2.96 3.17 3.56 6.85 1.81 10.95l-1.2 2.76c-1.24 2.83-2.51 5.76-3.6 8.72-.5 1.36-.45 3.29.13 4.78 1.93 5.02 4.06 10.15 6.36 15.27.68 1.51 1.95 2.87 3.23 3.47 2.76 1.29 5.64 2.41 8.42 3.5.94.37 1.88.73 2.81 1.11 4.35 1.74 6.62 4.81 6.75 9.12.16 5.62.16 11.25-.01 16.73-.13 4.18-2.35 7.2-6.59 8.95-1.4.58-2.81 1.13-4.22 1.69-2.4.94-4.88 1.92-7.27 3.01-1.24.56-2.44 1.85-3.07 3.28-2.28 5.16-4.45 10.39-6.43 15.55-.54 1.41-.59 3.22-.11 4.51 1.25 3.37 2.71 6.7 4.12 9.93l.68 1.55c1.82 4.18 1.21 7.95-1.84 11.2-3.81 4.06-7.73 7.97-11.65 11.61-1.96 1.82-4.15 2.74-6.5 2.74-1.42 0-2.92-.34-4.46-1-.94-.4-1.87-.81-2.81-1.22-2.72-1.2-5.54-2.44-8.4-3.46-.67-.24-1.47-.37-2.31-.37-.95 0-1.92.17-2.72.47-4.91 1.85-10.05 3.98-15.28 6.33-1.46.65-2.84 1.97-3.45 3.29-1.12 2.42-2.1 4.94-3.04 7.38-.5 1.29-1 2.58-1.53 3.86-1.76 4.29-4.75 6.53-8.9 6.66-2.81.09-5.6.13-8.29.13zm-43.27-37.23c1.06 0 2.17.28 3.5.89 5.88 2.69 12.2 5.3 19.34 7.99 2.47.93 3.79 2.14 4.55 4.18 2.04 5.44 3.71 9.59 5.42 13.45.52 1.18 2.15 2.56 3.55 2.63 2.29.12 4.55.13 6.46.13H201.88c2.71 0 3.67-1.75 4.16-3.06.76-2.03 1.59-4.08 2.39-6.06.94-2.32 1.92-4.72 2.79-7.12.74-2.03 2.01-3.2 4.54-4.16 6.59-2.5 13.09-5.2 19.32-8.01 1.39-.63 2.47-.91 3.5-.91.8 0 1.58.18 2.4.54 4.09 1.82 8.86 3.92 13.62 5.75.43.17.96.26 1.53.26 1.14 0 2.19-.33 2.8-.89 3.27-2.97 6.44-6.15 9.45-9.45.96-1.05 1.16-3.16.71-4.34-.77-2-1.64-3.98-2.47-5.9-1.13-2.59-2.3-5.27-3.22-7.96-.5-1.47-.39-3.64.27-5.41 1.36-3.63 2.89-7.27 4.37-10.8 1.24-2.96 2.52-6.02 3.7-9.06.91-2.35 1.97-3.53 3.76-4.2 5.45-2.04 9.81-3.8 13.72-5.52 1.21-.53 2.61-2.11 2.68-3.53.24-4.63.26-9.12.03-13.36-.08-1.46-1.56-3.11-2.85-3.69-4.57-2.05-9.16-3.82-13.44-5.44-1.91-.72-3.01-1.96-3.94-4.41-2.88-7.57-5.41-13.72-7.97-19.35-1.12-2.46-1.22-4.19-.33-6.17.95-2.14 1.87-4.29 2.79-6.44.96-2.24 1.94-4.56 2.95-6.81.59-1.31 1.03-3.04-.8-4.79-2.92-2.79-5.85-5.73-8.71-8.74-1.02-1.07-2.08-1.59-3.25-1.59-.71 0-1.48.19-2.33.59-2.21 1.02-4.5 1.98-6.72 2.92-2.06.87-4.19 1.76-6.26 2.71-.87.4-1.69.59-2.52.59-.99 0-2.06-.27-3.36-.86-6.59-2.99-13.19-5.73-19.6-8.15-2.39-.9-3.6-2.01-4.33-3.97-.87-2.34-1.82-4.68-2.74-6.95-.86-2.12-1.74-4.31-2.56-6.48-.77-2.04-2.03-2.94-4.08-2.94h-.15c-2.01.04-4.03.06-6.04.06s-4.21-.02-6.32-.06h-.13c-2.09 0-3.36.9-4.11 2.93-.83 2.22-1.73 4.46-2.61 6.62-.87 2.13-1.76 4.34-2.58 6.54-.81 2.17-2.14 3.39-4.73 4.34-5.88 2.16-12.02 4.72-19.32 8.05-1.3.59-2.37.87-3.36.87-.83 0-1.65-.19-2.52-.58-2.03-.92-4.12-1.8-6.13-2.65-2.26-.95-4.59-1.94-6.84-2.98-.87-.4-1.64-.59-2.35-.59-1.17 0-2.23.52-3.24 1.57-2.66 2.79-5.52 5.66-8.5 8.54-2.02 1.95-1.51 3.88-.84 5.34 1.56 3.43 3.04 6.97 4.47 10.39l.97 2.32c.29.69.53 1.4.82 2.22.1.29.2.58.31.89 0 0-.93 2.26-1.26 3.05-.77 1.86-1.56 3.71-2.34 5.56-1.94 4.57-3.95 9.3-5.73 14.04-.91 2.43-2.01 3.67-3.93 4.41-1.86.72-3.7 1.46-5.55 2.2-2.57 1.03-5.23 2.1-7.87 3.08-2.12.79-3.05 2.08-3.02 4.19.07 4.81.07 8.74 0 12.36-.06 2.81 1.66 3.82 3.17 4.39l1.67.62c3.96 1.48 8.06 3.01 11.9 4.87 1.28.62 2.65 2.17 3.41 3.84 1.53 3.41 2.98 6.94 4.38 10.35 1.31 3.18 2.66 6.47 4.08 9.68.97 2.18 1.06 3.69.33 5.36-.83 1.89-1.64 3.79-2.44 5.69-1.1 2.58-2.23 5.24-3.39 7.83-.63 1.4-1.11 3.24.81 5.08 3.42 3.28 6.18 6.06 8.69 8.75.95 1.02 1.96 1.52 3.09 1.52.74 0 1.51-.2 2.49-.66 2.35-1.09 4.78-2.12 7.13-3.12 1.86-.79 3.72-1.58 5.56-2.4.92-.41 1.79-.61 2.67-.61zM8.03 181.41c0 3.53.02 7.07.03 10.6.04 8.52.08 17.32-.12 25.97-.14 6.12 2.1 10.66 6.65 13.49 6.22 3.87 12.34 7.54 18.86 9.91 23.7 8.62 48.75 10.31 72.28 10.86h.73c6.76 0 10.17-2.52 11.41-8.44.08-.37.28-.77.5-1.2.28-.53.59-1.14.71-1.82.31-1.74.26-3.03-.14-4.06-2.14-5.45-4.36-10.76-6.6-15.78-.62-1.39-1.87-2.7-3.1-3.26-2.48-1.13-5.06-2.14-7.55-3.11-1.31-.52-2.63-1.03-3.94-1.56-4.04-1.65-6.21-4.61-6.66-9.04-.08-.77-.12-1.54-.16-2.38-.02-.42-.05-.86-.07-1.33l-.05-.87-.87-.08c-1.99-.18-3.96-.34-5.91-.51-4.32-.36-8.39-.7-12.52-1.17-12.23-1.38-28.19-3.77-43.19-10.06-4.39-1.84-8.71-4.16-12.89-6.41-1.96-1.05-3.92-2.11-5.91-3.13l-1.48-.76v4.13zm1.59-64.06c-.26 0-.47.09-.66.16-.06.02-.13.05-.2.07l-.72.22v.76c0 3.7.02 7.41.05 11.12.06 8.82.11 17.93-.16 26.88-.2 6.56 2.28 11.42 7.83 15.3 2.4 1.68 4.57 3.02 6.62 4.09 14.49 7.56 30.02 10.63 41.94 12.46 5.73.88 11.4 1.48 17.41 2.11 2.71.29 5.45.57 8.24.89l1.19.14-.06-1.2c-.35-7.06 2.59-11.16 9.54-13.27 1.08-.33 2.12-.78 3.12-1.22 1.08-.47 2.11-.92 3.17-1.22 3.58-1 5.6-3.12 6.35-6.67.37-1.78 1.02-4.35 2.34-6.19 4.38-6.09 4.36-12.46-.06-20.05-1.01-1.73-2.02-2.74-4.22-2.74h-.21c-2.52.07-5.06.1-7.55.1-18.11 0-35.71-1.8-52.31-5.35-12.93-2.76-27.9-6.85-40.97-16.19l-.27-.19-.38-.02zM8.03 60.84c0 3.48 0 6.97.02 10.45.02 8.67.04 17.64-.07 26.45-.07 5.07 1.66 8.92 5.12 11.46 4.02 2.94 8.84 6.28 14.12 8.75 12.13 5.67 25.13 8.23 36.25 9.98 13.17 2.08 26.52 3.13 39.68 3.13 2.61 0 5.25-.04 7.86-.12 1.39-.04 2.79-.96 3.56-1.73 1.96-1.95 3.92-3.98 5.81-5.93 2.34-2.42 4.75-4.92 7.2-7.3 1.92-1.87 4.11-2.82 6.53-2.82 1.46 0 3.04.35 4.67 1.03 1.32.55 2.64 1.13 3.95 1.7 2.43 1.06 4.95 2.16 7.49 3.11.54.2 1.16.3 1.85.3.89 0 1.82-.17 2.62-.48 5.3-2.05 10.53-4.21 15.54-6.43 1.41-.62 2.7-1.83 3.28-3.08 1.43-3.07 2.77-6.39 4.24-10.46 1.89-5.26 5.53-7.83 11.12-7.85H201.36V56.05l-1.54.92c-.99.6-1.96 1.2-2.9 1.79-1.98 1.24-3.86 2.4-5.81 3.41-18.94 9.76-39.4 13.01-56.91 14.91-9.95 1.08-19.95 1.63-29.72 1.63-12.77 0-25.56-.93-38.01-2.77-19.09-2.82-39.19-7.11-56.82-19.24l-1.59-1.1v5.25zM104.3 7.96c-18.52 0-36.97 2.01-54.85 5.98-10.51 2.33-22.68 5.74-33.26 13.33-5.52 3.96-8.28 8.11-8.19 12.35.09 4.16 2.91 8.09 8.4 11.7 5.8 3.81 12.36 6.98 19.5 9.43 23.18 7.95 46.83 9.66 68.93 10.31h.11c3.5-.27 7.01-.5 10.52-.73 7.75-.51 15.76-1.03 23.61-1.93 17.82-2.03 31.75-5.58 43.83-11.17 5.07-2.35 9.51-5.08 13.2-8.13 3.63-3 5.5-6.21 5.56-9.55.06-3.39-1.75-6.73-5.38-9.94-2.6-2.3-5.61-4.36-8.93-6.11-13.79-7.27-28.57-10.27-39.91-12.07-14.51-2.31-29.02-3.48-43.14-3.48zm90.43 252.2c-16.02 0-31.52-6.38-43.64-17.97-12.14-11.61-19.24-26.87-19.99-42.98-.81-17.53 5.1-34.22 16.65-47 11.41-12.63 26.99-20.07 43.88-20.95 1.21-.06 2.44-.1 3.64-.1 35.53 0 63.35 26.77 64.7 62.28.64 16.94-5.34 33.19-16.85 45.75-11.75 12.82-27.99 20.24-45.73 20.91-.9.04-1.79.06-2.67.06zm.84-121.05c-1.25 0-2.51.04-3.77.12-30.92 1.96-54.51 29.03-52.59 60.33 1.78 29 26.81 52.59 55.81 52.59.88 0 1.75-.02 2.63-.07 31.09-1.59 55.45-27.84 54.29-58.52-1.89-31.06-26.13-54.46-56.38-54.46zm.05 95.76c-21.65-.02-39.29-17.64-39.33-39.28-.04-21.58 17.61-39.2 39.34-39.27h.13c21.54 0 39.06 17.56 39.06 39.13 0 10.54-4.07 20.45-11.47 27.89-7.39 7.44-17.24 11.54-27.71 11.54h-.03zm-.1-70.49c-17.49.08-31.18 13.8-31.17 31.24.01 17.16 13.88 31.17 30.92 31.23h.11c17.27 0 31.37-14.03 31.42-31.29.02-8.28-3.21-16.09-9.09-22-5.91-5.92-13.74-9.19-22.05-9.19h-.14zM54.53 104.13c-.17 0-.34-.01-.51-.04-2.04-.29-4-.72-5.84-1.3-2.2-.69-3.25-2.52-2.74-4.78.42-1.89 2.03-2.93 4.53-2.93h.25c.43.1.9.19 1.4.29 1.35.27 2.87.58 4.33 1.07 1.86.62 2.85 2.68 2.3 4.77-.44 1.68-2 2.9-3.72 2.9zm-25.21-6.72c-.84-.4-1.66-.77-2.44-1.12-2.1-.95-3.91-1.77-5.52-2.87-1.69-1.15-1.47-3.1-.7-4.53.53-.99 1.52-2.17 3.18-2.17.35 0 .72.05 1.1.16 2.19.63 4.38 1.58 6.5 2.81 1.66.97 2.22 2.69 1.38 4.29-.47.91-1.43 1.7-2.44 2.54-.35.29-.7.58-1.05.89z"
                      />
                    </svg>
                  </div>
                  <div className="wdi-heading">PaaS</div>
                </div>
              </Link>
              <Link to="/cloud-computing/saas">
                <div
                  className={
                    accuratePath === "/cloud-computing/saas"
                      ? "item we-deals-list-inner active"
                      : "item we-deals-list-inner"
                  }
                  id="8"
                  onClick={() => setSubActive(0)}
                >
                  <div className="wdi-icon">
                    <svg data-name="Layer 1" viewBox="0 0 300 241.97">
                      <path
                        fill="#9cb5d4"
                        d="M220.96 241.96v-6.82h15.28c4.41 0 7.89-1.2 10.66-3.68 3.22-2.89 4.86-6.67 4.86-11.25v-8.85c.03-12.08.05-24.58-.02-36.87-.05-8.76-6.21-14.88-15-14.88-28.92 0-57.84-.01-86.75-.01s-57.77 0-86.66.01c-9 0-15.07 6.06-15.1 15.08-.04 10.96-.03 22.1-.02 32.87v11.07c.01 10.79 5.68 16.5 16.41 16.5h127.36v6.82H64.43c-14.2 0-23.02-8.88-23.03-23.16v-6.39c-.02-10.66-.03-21.69.04-32.54.01-2.33-.82-3.54-2.96-4.33-21.59-7.98-34.37-23.55-37.99-46.26-.07-.45-.24-.83-.4-1.17-.03-.07-.06-.13-.09-.2v-11.49c.21-1 .4-2.01.59-3.01.41-2.18.84-4.43 1.42-6.58 6.43-23.8 29.19-41.07 54.11-41.07.39 0 .77 0 1.16.01 2.22.05 4.5.23 6.51.39.91.07 1.78.14 2.6.2l.81.05.23-.77c.67-2.23 1.31-4.48 1.95-6.72 1.42-4.98 2.89-10.13 4.71-15.03 2.21-5.95 5.81-11.7 11.31-18.05l5.08 4.44-1.61 2.05c-7.34 9.34-11.89 19.94-13.51 31.51-.41 2.95.06 5.07 3.7 6.54 7.89 3.2 14.6 8.18 20.48 15.22l-5 4.11C83.05 78.1 70.6 72.22 57.51 72.22c-8.67 0-17.69 2.61-26.81 7.75-17.5 9.88-25.63 26.11-23.53 46.94 2.02 20.04 13.13 34.25 33.01 42.22l.51.2.45-.31c.13-.09.25-.16.34-.21.26-.15.58-.34.74-.75 4.21-10.73 10.95-15.31 22.53-15.31h169.27c13.1 0 19.15 4.07 23.98 16.14.13.32.34.53.48.66l.07.07.32.36.49-.02c9.22-.48 17.83-4.72 24.24-11.93 6.67-7.5 10.12-17.51 9.48-27.47-1.32-20.22-18.48-36.06-39.06-36.06-3.02 0-6.1.34-9.17 1.01v-.17c.08-1.27.14-2.5.21-3.74.56-9.89-3.53-17.5-11.82-22.01-3.62-1.97-7.3-2.96-10.95-2.96-4.77 0-9.46 1.69-13.93 5.02-1.7 1.26-3.29 2.63-5.12 4.21-.41.35-.82.71-1.26 1.08v-5.97c0-11.28-2.65-21.8-7.91-31.28-11.21-20.2-32.32-32.75-55.09-32.75-14.35 0-28.03 5.04-39.57 14.57-.45.37-.9.73-1.42 1.14l-.08.06-4.56-5.05C107.38 5.96 122.37 0 137.93 0c5.11 0 10.38.64 15.66 1.91 30.22 7.25 48.74 27.39 55.03 59.87l.23 1.2 1.14-.46c4.29-1.71 8.52-2.58 12.57-2.58 5.02 0 9.89 1.33 14.49 3.97 8.54 4.89 13.41 12.41 14.88 22.99l.12.87h.88c14.98.06 27.22 5.56 36.4 16.34 6.46 7.59 10.03 16.73 10.61 27.16 1.09 19.7-12.72 42.53-40.47 46.03l-.89.11v41.71c-.02 13.81-8.96 22.78-22.78 22.84-1.96 0-3.92.01-5.89.01h-8.95zm-17.75-.27v-6.42h6.42v6.42h-6.42zm-13.74-19.77c-.16 0-.33 0-.51-.03-.66-.06-1.38-.09-2.25-.09-.57 0-1.15.01-1.76.02-.33 0-.67.01-1.02.02l-.47-5.35-1.34.69c-3.63 1.86-6.89 2.76-9.97 2.76-2.27 0-4.46-.52-6.5-1.54-3.35-1.67-6.46-4.24-8.53-7.03-4.48-6.04-4.16-14.67.79-20.99 3.61-4.6 7.85-6.75 13.35-6.75 3.19 0 6.79.72 11 2.19l1.23.43.4-4.64h6.62c.05.47.1.92.1 1.35v11.22c0 8.49-.01 17.27.06 25.9 0 1.07-.16 1.47-.3 1.61-.18.18-.59.21-.9.21zm-17.08-31.75c-6.34 0-11.41 4.93-11.53 11.22-.06 3.02 1.09 5.89 3.23 8.09 2.17 2.23 5.06 3.47 8.14 3.49 6.4 0 11.54-5.1 11.56-11.37.02-6.2-5.01-11.32-11.2-11.43h-.2zm-35.93 31.69l-.39-5.01-1.26.46c-4.12 1.5-7.69 2.23-10.91 2.23-5.48 0-9.85-2.21-13.36-6.75-4.94-6.38-5.2-15.06-.65-21.59 3.58-5.13 7.85-7.42 13.82-7.42 3.16 0 6.81.66 11.14 2l1.23.38.31-4.58h6.49v40.27h-6.43zm-11.53-31.69c-6.39 0-11.4 4.99-11.42 11.37 0 3.09 1.17 5.97 3.3 8.11 2.14 2.14 5.01 3.32 8.1 3.32 6.32-.01 11.31-4.94 11.39-11.2.04-3.12-1.12-6.04-3.26-8.22-2.12-2.16-4.96-3.36-8.02-3.39h-.09zm-44.32 31.67c-.32 0-.63 0-.95-.03-7.59-.42-13.68-3.66-18.6-9.88l4.76-4.39c.22.21.43.41.63.61.9.86 1.73 1.65 2.57 2.42 3.24 2.91 6.88 4.39 10.82 4.39 1 0 2.04-.1 3.08-.29 3.65-.67 6.52-3.41 6.7-6.37.22-3.79-2.55-5.53-4.98-6.63-3.26-1.47-6.63-2.8-9.89-4.1l-2.66-1.06c-4.3-1.72-6.72-4.86-7.2-9.32-.54-4.96 1.39-8.97 5.56-11.61 2.93-1.85 6.05-2.79 9.28-2.79s6.47.89 9.9 2.64c1.8.92 3.5 2.13 5.29 3.4.57.4 1.14.81 1.73 1.22l-4.03 4.81c-.95-.45-1.88-.9-2.8-1.35-2.74-1.34-5.33-2.6-8.09-3.46-.57-.18-1.22-.27-1.92-.27-1.58 0-3.45.47-5.01 1.27-1.68.86-2.89 3.29-2.96 5.02-.07 1.68 1.88 3.56 3.27 4.22 2.15 1.02 4.4 1.9 6.58 2.76 1.69.66 3.45 1.35 5.13 2.1 6.36 2.82 9.43 6.72 9.66 12.25.14 3.39-1.19 6.72-3.75 9.38-3.08 3.21-7.49 5.06-12.1 5.06zm140.75-.02c-7.93-.18-14.24-3.43-19.27-9.92l5.01-4.57c.12.14.24.28.36.41.74.85 1.5 1.73 2.33 2.53 3.25 3.1 6.97 4.68 11.07 4.68 1.08 0 2.21-.11 3.34-.33 3.46-.68 6.23-3.36 6.44-6.24.29-3.84-2.47-5.59-4.91-6.69-3.14-1.41-6.39-2.7-9.53-3.94l-3.03-1.2c-4.4-1.77-6.86-4.99-7.29-9.57-.46-4.82 1.46-8.75 5.54-11.36 2.93-1.88 6.07-2.83 9.32-2.83 2.91 0 5.96.76 9.08 2.26 2.06.99 3.97 2.3 5.99 3.69.63.43 1.27.87 1.91 1.3l-4.08 4.84c-.93-.44-1.83-.89-2.73-1.33-2.72-1.35-5.3-2.62-8.07-3.46-.57-.17-1.21-.26-1.9-.26-1.58 0-3.5.47-5.27 1.3-1.61.75-2.84 3.25-2.84 4.9 0 1.6 1.69 3.52 3.2 4.23 2.11 1 4.31 1.86 6.44 2.69 1.83.71 3.72 1.45 5.53 2.27 6.33 2.87 9.34 6.8 9.48 12.36.09 3.39-1.28 6.71-3.85 9.35-3.04 3.12-7.37 4.91-11.88 4.91h-.4zM182.37 64.96v-6.5h6.39v6.5h-6.39zm-8.82-17.72v-6.45h6.44v6.45h-6.44z"
                      />
                    </svg>
                  </div>
                  <div className="wdi-heading">SaaS</div>
                </div>
              </Link>
            </Slider>

            {accuratePath === "/cloud-computing" ||
              accuratePath === "/cloud-computing/cloud-infrastructure" ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="sap-tab-vert d-flex align-items-start"
                id="web-design"
              >
                <Tabs
                  selectedIndex={subActive}
                  onSelect={(index) => setSubActive(index)}
                >
                  <TabList className="nav flex-column nav-pills me-3 react-tabs__tab-list">
                    <Tab>
                      <Link to="/cloud-computing/cloud-infrastructure">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Cloud Infrastructure
                        </div>
                      </Link>
                    </Tab>
                  </TabList>
                  <div className="tab-content">
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        {/* <MetaTags>
                          <meta
                            id="meta-description"
                            name="description"
                            content="Experience tailored cloud infrastructure solutions today. Improve your business's efficiency by optimizing resources. Get in touch with us now."
                          />
                        </MetaTags> */}
                       
                        {path === '/cloud-computing' && (
                             <Helmet>
                             <title>Leading Cloud Service Provider with server based computing</title>
                             <meta
                               name="keyword"
                               content="cloud service provider, server based computing, google cloud computing, hosting cloud computing"
                             />
                             <meta
                               name="description"
                               content="Kindlebit is a cloud service provider offering server-based computing, Google Cloud computing, and hosting cloud computing for all your business needs."
                             />
                           </Helmet>
                          )}
                          {path === '/cloud-computing/cloud-infrastructure' && (
                           <Helmet>
                           <title>Discover the Reliable Cloud Service Provider for SaaS Solutions</title>
                           <meta
                             name="keyword"
                             content="cloud service provider, saas and cloud computing"
                           />
                           <meta
                             name="description"
                             content="Power your business with top-tier cloud service providers. Experience seamless SaaS and cloud computing for smarter, faster operations."
                           />
                         </Helmet>
                          )}


                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Cloud Infrastructure
                            </div>
                            <div className="text-para">
                              Cloud Infrastructure encompasses the hardware,
                              software, resources which are used to achieve
                              cloud computing. It helps businesses, individuals,
                              companies etc. get the best out of the resources
                              they have while they can avail other resources
                              from different vendors thus helping different
                              stakeholders run their business, tasks etc
                              efficiently. It further includes server
                              management, database management, SaaS, IaaS and
                              PaaS.
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                  </div>
                </Tabs>
              </motion.div>
            ) : (
              ""
            )}
            {accuratePath === "/server-management" ||
              accuratePath === "/cloud-computing/server-management" ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="sap-tab-vert d-flex align-items-start"
                id="web-design"
              >
                <Tabs
                  selectedIndex={subActive}
                  onSelect={(index) => setSubActive(index)}
                >
                  <TabList className="nav flex-column nav-pills me-3 react-tabs__tab-list">
                    <Tab>
                      <Link to="/cloud-computing/server-management">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Server Management
                        </div>
                      </Link>
                    </Tab>
                  </TabList>
                  <div className="tab-content">
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >

                        {/* <MetaTags>
                          <meta
                            id="meta-description"
                            name="description"
                            content="Use Kindlebit's server management services to maximize your cloud's performance. Contact us now for smooth business operations!"
                          />
                        </MetaTags> */}
                        <Helmet>
                          <title>Server Management Services | SQL & System Management</title>
                          <meta
                            name="keyword"
                            content="system management server, web management services, sql server management studio, server management services"
                          />
                          <meta
                            name="description"
                            content="Optimize performance with expert server management services, including system management server solutions, web management services, and SQL Server Management
"
                          />
                        </Helmet>

                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Server Management
                            </div>
                            <div className="text-para">
                              Server management is all of the monitoring and
                              upkeep needed for servers to run dependably and at
                              peak performance levels are included in server
                              administration. In order to maintain the IT
                              environment functional and effective, server
                              management also includes managing the hardware,
                              software, security, and backups. This in turn
                              helps, in:
                            </div>
                            <ul>
                              <li>
                                Maintaining higher up time and minimizing server
                                slow downs.
                              </li>
                              <li>
                                Scaling of the server operations as per the
                                needs of the organization.
                              </li>
                              <li>
                                Increasing security and reliability of the
                                server.
                              </li>
                            </ul>
                            For any server to run properly it runs on a few
                            basic parameters which govern it, they include:
                            <ul>
                              <li>Hardware management</li>
                              <li>Operating environment</li>
                              <li>Software management</li>
                              <li>Security</li>
                              <li>Data backups</li>
                              <li>Power backups</li>
                            </ul>
                          </div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                  </div>
                </Tabs>
              </motion.div>
            ) : (
              ""
            )}
            {accuratePath === "/cloud-computing/server-management-kindlebit" ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="sap-tab-vert d-flex align-items-start"
                id="web-design"
              >
                <Tabs
                  selectedIndex={subActive}
                  onSelect={(index) => setSubActive(index)}
                >
                  <TabList className="nav flex-column nav-pills me-3 react-tabs__tab-list">
                    <Tab>
                      <Link to="/cloud-computing/server-management-kindlebit">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Server management with Kindlebit
                        </div>
                      </Link>
                    </Tab>
                  </TabList>
                  <div className="tab-content">
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        {/* <MetaTags>
                          <meta
                            id="meta-description"
                            name="description"
                            content="Want to optimize your business operations? Then, get our expert server management services. Our advanced IT tools ensure smooth business operations."
                          />
                        </MetaTags> */}
                        <Helmet>
                          <title>Expert Network Performance Monitoring Server |  Kindlebit</title>
                          <meta
                            name="keyword"
                            content="server performance monitoring, linux server management, network monitoring server, it server management"
                          />
                          <meta
                            name="description"
                            content="Offering server performance monitoring, Linux server management, network monitoring server solutions, and server management to optimize efficiency and security
"
                          />
                        </Helmet>


                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Server management with Kindlebit
                            </div>
                            <div className="text-para">
                              At Kindlebit we have managed servers for countless
                              big and small organizations. We have provided a
                              suite of IT tools that help these organizations
                              run business effectively. Our services include:
                            </div>
                            <ul>
                              <li>Remote monitoring and management</li>
                              <li>Automate tasks</li>
                              <li>Comprehensive patch management</li>
                              <li>Fast and secure remote access</li>
                              <li>Integrated cloud backup</li>
                            </ul>
                          </div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                  </div>
                </Tabs>
              </motion.div>
            ) : (
              ""
            )}
            {accuratePath === "/backup-management" ||
              accuratePath === "/cloud-computing/database-management" ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="sap-tab-vert d-flex align-items-start"
                id="web-design"
              >
                <Tabs
                  selectedIndex={subActive}
                  onSelect={(index) => setSubActive(index)}
                >
                  <TabList className="nav flex-column nav-pills me-3 react-tabs__tab-list">
                    <Tab>
                      <Link to="/cloud-computing/database-management">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Database Management
                        </div>
                      </Link>
                    </Tab>
                  </TabList>
                  <div className="tab-content">
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >

                        {/* <MetaTags>
                          <meta
                            id="meta-description"
                            name="description"
                            content=" Use our database management services to boost your business efficiency. Our services include performance monitoring, backup, and more. Contact us today!"
                          />
                        </MetaTags> */}
                        <Helmet>
                          <title>Database Management System & Services | Online DB Solutions</title>
                          <meta
                            name="keyword"
                            content="database management system, database and management system, online database management system, database management service"
                          />
                          <meta
                            name="description"
                            content="Providing database management system solutions, online database management system, and database management service to ensure efficient and secure data handling
"
                          />
                        </Helmet>


                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Database Management
                            </div>
                            <div className="text-para">
                              For any business to function efficiently, it
                              requires good database management to get clear
                              insights into users thus providing businesses with
                              the opportunity to cater their products
                              accordingly. Database management helps prevent
                              unauthorized access, data rollback, data deletion
                              and replication etc. thus giving the organizations
                              assurance of their data. Our Database Management
                              services include:
                            </div>
                            <ul>
                              <li>Performance monitoring and tuning</li>
                              <li>Storage upgradation</li>
                              <li>Backup and recovery</li>
                              <li>Data archiving</li>
                              <li>Data partitioning</li>
                              <li>Data replication</li>
                              <li>Data masking</li>
                              <li>Data deletion and complete wipe</li>
                            </ul>
                          </div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                  </div>
                </Tabs>
              </motion.div>
            ) : (
              ""
            )}
            {accuratePath === "/cloud-computing/iaas" ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="sap-tab-vert d-flex align-items-start"
                id="web-design"
              >
                <Tabs
                  selectedIndex={subActive}
                  onSelect={(index) => setSubActive(index)}
                >
                  <TabList className="nav flex-column nav-pills me-3 react-tabs__tab-list">
                    <Tab>
                      <Link to="/cloud-computing/iaas">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          IaaS
                        </div>
                      </Link>
                    </Tab>
                  </TabList>
                  <div className="tab-content">
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <Helmet>
                          <title>IaaS Cloud Services | Infrastructure as a Service Providers</title>
                          <meta
                            name="keyword"
                            content="iaas cloud services, iaas service providers, iaas infrastructure as a service, iaas in cloud computing"
                          />
                          <meta
                            name="description"
                            content="We offer IaaS cloud services and comprehensive cloud computing. As trusted IaaS service providers, we deliver scalable infrastructure as a service solutions
"
                          />
                        </Helmet>


                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">IaaS</div>
                            <div className="text-para">
                              Infrastructure as a service is a cloud computing
                              platform where businesses have the option to
                              outsource their IT infrastructures, including
                              their servers, networking, processing, storage,
                              virtual machines, and other assets. Businesses
                              employ a pay-per-use business model to access
                              these resources on the Internet. Thus leading to
                              decreased cost for them which further translates
                              to serving their customers better while keeping
                              healthy margins for them.
                              <br />
                              Our services include:
                              <ul>
                                <li>AWS app development</li>
                                <li>AWS consulting</li>
                                <li>Google Cloud development services</li>
                                <li>Microsoft Azure development services</li>
                                <li>Implementation and migration</li>
                                <li>DevOps</li>
                                <li>Monitoring, management and support</li>
                              </ul>
                            </div>
                          </div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                  </div>
                </Tabs>
              </motion.div>
            ) : (
              ""
            )}
            {accuratePath === "/cloud-computing/paas" ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="sap-tab-vert d-flex align-items-start"
                id="web-design"
              >
                <Tabs
                  selectedIndex={subActive}
                  onSelect={(index) => setSubActive(index)}
                >
                  <TabList className="nav flex-column nav-pills me-3 react-tabs__tab-list">
                    <Tab>
                      <Link to="/cloud-computing/paas">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          PaaS
                        </div>
                      </Link>
                    </Tab>
                  </TabList>
                  <div className="tab-content">
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <Helmet>
                          <title>PaaS Platform & Application Development | PaaS Providers</title>
                          <meta
                            name="keyword"
                            content="paas platform as a service, paas application development, cloud paas providers, paas service providers"
                          />
                          <meta
                            name="description"
                            content="Providing PaaS platform as a service for efficient application development. As leading PaaS providers and cloud PaaS providers, we offer scalable solutions.
"
                          />
                        </Helmet>


                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">PaaS</div>
                            <div className="text-para">
                              PaaS or Platform as a Service is a cloud computing
                              platform that gives businesses flexibility of
                              offloading their task of managing servers,
                              networks, storage, operating system software,
                              databases, development tools from their end to
                              third parties. Hence businesses need not worry
                              about these things and can function on other
                              aspects of their business. PaaS use cases include
                              API development and management, Internet of
                              Things(IoT), Agile development and DevOps, Hybrid
                              cloud. PaaS also helps develop cloud native
                              applications. Thus PaaS acts an important solution
                              in taking the business forward.
                              <br />
                              Our PaaS services include:
                              <ul>
                                <li>AWS Lambda development</li>
                                <li>Microsoft Azure Function and Logic Apps</li>
                                <li>Google Cloud Run development</li>
                              </ul>
                            </div>
                          </div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                  </div>
                </Tabs>
              </motion.div>
            ) : (
              ""
            )}
            {accuratePath === "/cloud-computing/saas" ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="sap-tab-vert d-flex align-items-start"
                id="web-design"
              >
                <Tabs
                  selectedIndex={subActive}
                  onSelect={(index) => setSubActive(index)}
                >
                  <TabList className="nav flex-column nav-pills me-3 react-tabs__tab-list">
                    <Tab>
                      <Link to="/cloud-computing/saas">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          SaaS
                        </div>
                      </Link>
                    </Tab>
                  </TabList>
                  <div className="tab-content">
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        {/* <MetaTags>
                          <meta
                            id="meta-description"
                            name="description"
                            content="Want to optimize your business operations, right? Leverage our Software as a Service (SaaS) services. Get scalability, safety, and efficiency now!"
                          />
                        </MetaTags> */}

                        <Helmet>
                          <title>Leading SaaS Development & Cloud Computing | SaaS Company</title>
                          <meta
                            name="keyword"
                            content="saas and cloud computing, saas development company, saas software as a service, saas in cloud computing, leading saas companies"
                          />
                          <meta
                            name="description"
                            content="Offering SaaS and cloud computing solutions, our SaaS development company delivers Software as a Service in real-time, recognized among leading SaaS companies
"
                          />
                        </Helmet>

                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">SaaS</div>
                            <div className="text-para">
                              SaaS or software as a service is a complete
                              solution which businesses use where everything is
                              handled by the third party and payment is made to
                              use the service thus providing complete
                              convenience to the end user. SaaS solutions are
                              geared for businesses who have just started out
                              and do not have the technical know-how to achieve
                              success in the business but could build great
                              products or services with the help of these
                              softwares.
                              <br />
                              Advantages of SaaS include:
                              <ul>
                                <li>Low setup and infrastructure costs</li>
                                <li>Accessible from anywhere</li>
                                <li>Scalability</li>
                                <li>Automatic and frequent updates</li>
                                <li>Security upgradation is easier.</li>
                              </ul>
                            </div>
                          </div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                  </div>
                </Tabs>
              </motion.div>
            ) : (
              ""
            )}
          </div>
        </section>
      </main>

      {/* Contact modal */}
      {commonModal && (
        <ContactModal
          commonModal={commonModal}
          setCommonModal={setCommonModal}
        />
      )}
    </>
  );
}
export default CloudComputing;
